(() => {
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $a2852b0e2c248fe9$export$8c556d9177439d09 = /*#__PURE__*/ function() {
    function e(e, t, n) {
        this.localPeer = void 0, this.whppUrl = void 0, this.iceGatheringTimeout = void 0, this.waitingForCandidates = !1, this.resourceUrl = void 0, this.opts = void 0, this.localPeer = e, this.whppUrl = t, this.opts = n, this.localPeer.onicegatheringstatechange = this.onIceGatheringStateChange.bind(this), this.localPeer.oniceconnectionstatechange = this.onIceConnectionStateChange.bind(this), this.localPeer.onicecandidateerror = this.onIceCandidateError.bind(this), this.localPeer.onicecandidate = this.onIceCandidate.bind(this);
    }
    var t = e.prototype;
    return t.getPeer = function() {
        return this.localPeer;
    }, t.connect = function() {
        try {
            var e, t = this;
            return Promise.resolve(fetch(t.whppUrl.href, {
                method: "POST",
                headers: {
                    "Content-Type": null != (e = t.opts) && e.useLegacyContentType ? "application/json" : "application/whpp+json"
                },
                body: "{}"
            })).then(function(e) {
                var n;
                function o(o) {
                    return n ? o : Promise.resolve(e.json()).then(function(n) {
                        var o = e.headers.get("location");
                        return t.resourceUrl = new URL(o), t.log(n.offer), Promise.resolve(function(e) {
                            try {
                                return Promise.resolve(fetch(e.href, {
                                    method: "OPTIONS"
                                })).then(function(e) {
                                    return !(!e.ok || !e.headers.get("Allow") || !e.headers.get("Allow").split(",").find(function(e) {
                                        return "PATCH" === e.trimStart();
                                    }));
                                });
                            } catch (e) {
                                return Promise.reject(e);
                            }
                        }(t.resourceUrl)).then(function(e) {
                            return t.log("ICE trickle supported by endpoint: " + e), t.opts || (t.opts = {}), t.opts.noIceTrickle = !e, t.supportsTrickleIce() || (t.waitingForCandidates = !0), Promise.resolve(t.localPeer.setRemoteDescription({
                                type: "offer",
                                sdp: n.offer
                            })).then(function() {
                                return Promise.resolve(t.localPeer.createAnswer()).then(function(e) {
                                    return Promise.resolve(t.localPeer.setLocalDescription(e)).then(function() {
                                        var e = function() {
                                            if (t.supportsTrickleIce()) return t.log("ICE trickle supported, sending answer"), Promise.resolve(t.sendAnswer()).then(function() {});
                                            var e;
                                            t.iceGatheringTimeout = setTimeout(t.onIceGatheringTimeout.bind(t), (null == (e = t.opts) ? void 0 : e.timeout) || 2e3);
                                        }();
                                        if (e && e.then) return e.then(function() {});
                                    });
                                });
                            });
                        });
                    });
                }
                var r = function() {
                    if (!e.ok) return function() {
                        if (415 === e.status) return t.opts.useLegacyContentType = !0, Promise.resolve(fetch(t.whppUrl.href, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: "{}"
                        })).then(function(t) {
                            e = t;
                        });
                        n = 1;
                    }();
                }();
                return r && r.then ? r.then(o) : o(r);
            });
        } catch (e) {
            return Promise.reject(e);
        }
    }, t.log = function() {
        var e, t;
        null != (e = this.opts) && e.debug && (t = console).log.apply(t, [
            "whpp-client"
        ].concat([].slice.call(arguments)));
    }, t.error = function() {
        var e;
        (e = console).error.apply(e, [
            "whpp-client"
        ].concat([].slice.call(arguments)));
    }, t.onIceGatheringStateChange = function(e) {
        this.log("IceGatheringState", this.localPeer.iceGatheringState), "complete" === this.localPeer.iceGatheringState && !this.supportsTrickleIce() && this.waitingForCandidates && this.onDoneWaitingForCandidates();
    }, t.onIceConnectionStateChange = function(e) {
        this.log("IceConnectionState", this.localPeer.iceConnectionState), "failed" === this.localPeer.iceConnectionState && this.localPeer.close();
    }, t.onIceCandidate = function(e) {
        try {
            var t = this;
            if ("icecandidate" !== e.type) return Promise.resolve();
            var n = e.candidate;
            return n ? (t.log("IceCandidate", n.candidate), t.supportsTrickleIce() ? (t.sendCandidate(n), Promise.resolve()) : Promise.resolve()) : Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    }, t.onIceCandidateError = function(e) {
        this.log("IceCandidateError", e);
    }, t.onIceGatheringTimeout = function() {
        this.log("IceGatheringTimeout"), !this.supportsTrickleIce() && this.waitingForCandidates && this.onDoneWaitingForCandidates();
    }, t.supportsTrickleIce = function() {
        return this.opts && !this.opts.noIceTrickle;
    }, t.onDoneWaitingForCandidates = function() {
        try {
            var e = this;
            return e.waitingForCandidates = !1, clearTimeout(e.iceGatheringTimeout), Promise.resolve(e.sendAnswer()).then(function() {});
        } catch (e) {
            return Promise.reject(e);
        }
    }, t.sendCandidate = function(e) {
        try {
            var t, n = this;
            return Promise.resolve(fetch(n.resourceUrl.href, {
                method: "PATCH",
                headers: {
                    "Content-Type": null != (t = n.opts) && t.useLegacyContentType ? "application/json" : "application/whpp+json"
                },
                body: JSON.stringify({
                    candidate: e.candidate
                })
            })).then(function(e) {
                e.ok || (n.error("sendCandidate response: " + e.status), 405 === e.status && n.log("ICE trickle not supported by endpoint"));
            });
        } catch (e) {
            return Promise.reject(e);
        }
    }, t.sendAnswer = function() {
        try {
            var e, t = this, n = {
                answer: t.localPeer.localDescription.sdp
            };
            return t.log(n.answer), Promise.resolve(fetch(t.resourceUrl.href, {
                method: "PUT",
                headers: {
                    "Content-Type": null != (e = t.opts) && e.useLegacyContentType ? "application/json" : "application/whpp+json"
                },
                body: JSON.stringify(n)
            })).then(function(e) {
                e.ok || t.error("sendAnswer response: " + e.status);
            });
        } catch (e) {
            return Promise.reject(e);
        }
    }, e;
}();


class $4eb2d767b36cee6c$export$1bee3ffe1758e87d {
    client = undefined;
    localPeer = undefined;
    channelUrl;
    debug = false;
    constructor(peer, channelUrl, onError){
        this.channelUrl = channelUrl;
        this.resetPeer(peer);
    }
    enableDebug() {
        this.debug = true;
    }
    resetPeer(newPeer) {
        this.localPeer = newPeer;
    }
    getPeer() {
        return this.localPeer;
    }
    async connect(opts) {
        if (this.localPeer) {
            this.client = new (0, $a2852b0e2c248fe9$export$8c556d9177439d09)(this.localPeer, this.channelUrl, {
                debug: this.debug
            });
            await this.client.connect();
        }
    }
    async disconnect() {
        return;
    }
    log(...args) {
        if (this.debug) console.log("WebRTC-player", ...args);
    }
    error(...args) {
        console.error("WebRTC-player", ...args);
    }
}


const $2efa4b85661d6410$var$DEFAULT_CONNECT_TIMEOUT = 2000;
class $2efa4b85661d6410$export$5463baa67f138efa {
    localPeer;
    channelUrl;
    debug;
    iceGatheringTimeout;
    waitingForCandidates = false;
    resourceUrl = undefined;
    constructor(peer, channelUrl, onError){
        this.channelUrl = channelUrl;
        this.debug = true;
        this.resetPeer(peer);
    }
    enableDebug() {
        this.debug = true;
    }
    resetPeer(newPeer) {
        this.localPeer = newPeer;
        this.localPeer.onicegatheringstatechange = this.onIceGatheringStateChange.bind(this);
        this.localPeer.oniceconnectionstatechange = this.onIceConnectionStateChange.bind(this);
        this.localPeer.onicecandidateerror = this.onIceCandidateError.bind(this);
        this.localPeer.onicecandidate = this.onIceCandidate.bind(this);
    }
    getPeer() {
        return this.localPeer;
    }
    async connect(opts) {
        if (!this.localPeer) {
            this.log("Local RTC peer not initialized");
            return;
        }
        this.localPeer.addTransceiver("video", {
            direction: "recvonly"
        });
        this.localPeer.addTransceiver("audio", {
            direction: "recvonly"
        });
        const offer = await this.localPeer.createOffer({
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
        });
        this.localPeer.setLocalDescription(offer);
        this.waitingForCandidates = true;
        this.iceGatheringTimeout = setTimeout(this.onIceGatheringTimeout.bind(this), opts && opts.timeout || $2efa4b85661d6410$var$DEFAULT_CONNECT_TIMEOUT);
    }
    async disconnect() {
        return;
    }
    log(...args) {
        if (this.debug) console.log("WebRTC-player", ...args);
    }
    error(...args) {
        console.error("WebRTC-player", ...args);
    }
    onIceGatheringStateChange(event) {
        if (!this.localPeer) {
            this.log("Local RTC peer not initialized");
            return;
        }
        this.log("IceGatheringState", this.localPeer.iceGatheringState);
        if (this.localPeer.iceGatheringState !== "complete" || !this.waitingForCandidates) return;
        this.onDoneWaitingForCandidates();
    }
    onIceConnectionStateChange() {
        if (!this.localPeer) {
            this.log("Local RTC peer not initialized");
            return;
        }
        this.log("IceConnectionState", this.localPeer.iceConnectionState);
        if (this.localPeer.iceConnectionState === "failed") this.localPeer.close();
    }
    async onIceCandidate(event) {
        if (event.type !== "icecandidate") return;
        const candidateEvent = event;
        const candidate = candidateEvent.candidate;
        if (!candidate) return;
        this.log("IceCandidate", candidate.candidate);
    }
    onIceCandidateError(e) {
        this.log("IceCandidateError", e);
    }
    onIceGatheringTimeout() {
        this.log("IceGatheringTimeout");
        if (!this.waitingForCandidates) return;
        this.onDoneWaitingForCandidates();
    }
    async onDoneWaitingForCandidates() {
        if (!this.localPeer) {
            this.log("Local RTC peer not initialized");
            return;
        }
        this.waitingForCandidates = false;
        clearTimeout(this.iceGatheringTimeout);
        const response = await fetch(this.channelUrl.toString(), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                sdp: this.localPeer.localDescription?.sdp
            })
        });
        if (response.ok) {
            const { sdp: sdp } = await response.json();
            this.localPeer.setRemoteDescription({
                type: "answer",
                sdp: sdp
            });
        }
    }
}


const $197a0bf6c144c0fc$var$DEFAULT_CONNECT_TIMEOUT = 2000;
var $197a0bf6c144c0fc$export$2351e2e8d1fcfd84;
(function(WHEPType) {
    WHEPType[WHEPType["Client"] = 0] = "Client";
    WHEPType[WHEPType["Server"] = 1] = "Server";
})($197a0bf6c144c0fc$export$2351e2e8d1fcfd84 || ($197a0bf6c144c0fc$export$2351e2e8d1fcfd84 = {}));
class $197a0bf6c144c0fc$export$e35e1b35ea68c1 {
    localPeer;
    channelUrl;
    debug = false;
    whepType;
    waitingForCandidates = false;
    iceGatheringTimeout;
    resource = null;
    onErrorHandler;
    audio;
    video;
    mediaConstraints;
    constructor(peer, channelUrl, onError, mediaConstraints){
        this.mediaConstraints = mediaConstraints;
        this.channelUrl = channelUrl;
        if (typeof this.channelUrl === "string") throw new Error(`channelUrl parameter expected to be an URL not a string`);
        this.whepType = $197a0bf6c144c0fc$export$2351e2e8d1fcfd84.Client;
        this.onErrorHandler = onError;
        this.audio = !this.mediaConstraints.videoOnly;
        this.video = !this.mediaConstraints.audioOnly;
        this.resetPeer(peer);
    }
    enableDebug() {
        this.debug = true;
    }
    resetPeer(newPeer) {
        this.localPeer = newPeer;
        this.localPeer.onicegatheringstatechange = this.onIceGatheringStateChange.bind(this);
        this.localPeer.onicecandidate = this.onIceCandidate.bind(this);
    }
    getPeer() {
        return this.localPeer;
    }
    async connect(opts) {
        try {
            await this.initSdpExchange();
        } catch (error) {
            console.error(error.toString());
        }
    }
    async disconnect() {
        if (this.resource) {
            this.log(`Disconnecting by removing resource ${this.resource}`);
            const response = await fetch(this.resource, {
                method: "DELETE"
            });
            if (response.ok) this.log(`Successfully removed resource`);
        }
    }
    async initSdpExchange() {
        clearTimeout(this.iceGatheringTimeout);
        if (this.localPeer && this.whepType === $197a0bf6c144c0fc$export$2351e2e8d1fcfd84.Client) {
            if (this.video) this.localPeer.addTransceiver("video", {
                direction: "recvonly"
            });
            if (this.audio) this.localPeer.addTransceiver("audio", {
                direction: "recvonly"
            });
            const offer = await this.localPeer.createOffer();
            // To add NACK in offer we have to add it manually see https://bugs.chromium.org/p/webrtc/issues/detail?id=4543 for details
            if (offer.sdp) {
                const opusCodecId = offer.sdp.match(/a=rtpmap:(\d+) opus\/48000\/2/);
                if (opusCodecId !== null) offer.sdp = offer.sdp.replace("opus/48000/2\r\n", "opus/48000/2\r\na=rtcp-fb:" + opusCodecId[1] + " nack\r\n");
            }
            await this.localPeer.setLocalDescription(offer);
            this.waitingForCandidates = true;
            this.iceGatheringTimeout = setTimeout(this.onIceGatheringTimeout.bind(this), $197a0bf6c144c0fc$var$DEFAULT_CONNECT_TIMEOUT);
        } else if (this.localPeer) {
            const offer = await this.requestOffer();
            await this.localPeer.setRemoteDescription({
                type: "offer",
                sdp: offer
            });
            const answer = await this.localPeer.createAnswer();
            try {
                await this.localPeer.setLocalDescription(answer);
                this.waitingForCandidates = true;
                this.iceGatheringTimeout = setTimeout(this.onIceGatheringTimeout.bind(this), $197a0bf6c144c0fc$var$DEFAULT_CONNECT_TIMEOUT);
            } catch (error) {
                this.log(answer.sdp);
                throw error;
            }
        }
    }
    async onIceCandidate(event) {
        if (event.type !== "icecandidate") return;
        const candidateEvent = event;
        const candidate = candidateEvent.candidate;
        if (!candidate) return;
        this.log(candidate.candidate);
    }
    onIceGatheringStateChange(event) {
        if (this.localPeer) {
            this.log("IceGatheringState", this.localPeer.iceGatheringState);
            if (this.localPeer.iceGatheringState !== "complete" || !this.waitingForCandidates) return;
            this.onDoneWaitingForCandidates();
        }
    }
    onIceGatheringTimeout() {
        this.log("IceGatheringTimeout");
        if (!this.waitingForCandidates) return;
        this.onDoneWaitingForCandidates();
    }
    async onDoneWaitingForCandidates() {
        this.waitingForCandidates = false;
        clearTimeout(this.iceGatheringTimeout);
        if (this.whepType === $197a0bf6c144c0fc$export$2351e2e8d1fcfd84.Client) await this.sendOffer();
        else await this.sendAnswer();
    }
    getResouceUrlFromHeaders(headers) {
        if (headers.get("Location") && headers.get("Location")?.match(/^\//)) {
            const resourceUrl = new URL(headers.get("Location"), this.channelUrl.origin);
            return resourceUrl.toString();
        } else return headers.get("Location");
    }
    async requestOffer() {
        if (this.whepType === $197a0bf6c144c0fc$export$2351e2e8d1fcfd84.Server) {
            this.log(`Requesting offer from: ${this.channelUrl}`);
            const response = await fetch(this.channelUrl.toString(), {
                method: "POST",
                headers: {
                    "Content-Type": "application/sdp"
                },
                body: ""
            });
            if (response.ok) {
                this.resource = this.getResouceUrlFromHeaders(response.headers);
                this.log("WHEP Resource", this.resource);
                const offer = await response.text();
                this.log("Received offer", offer);
                return offer;
            } else {
                const serverMessage = await response.text();
                throw new Error(serverMessage);
            }
        }
    }
    async sendAnswer() {
        if (!this.localPeer) {
            this.log("Local RTC peer not initialized");
            return;
        }
        if (this.whepType === $197a0bf6c144c0fc$export$2351e2e8d1fcfd84.Server && this.resource) {
            const answer = this.localPeer.localDescription;
            if (answer) {
                const response = await fetch(this.resource, {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/sdp"
                    },
                    body: answer.sdp
                });
                if (!response.ok) this.error(`sendAnswer response: ${response.status}`);
            }
        }
    }
    async sendOffer() {
        if (!this.localPeer) {
            this.log("Local RTC peer not initialized");
            return;
        }
        const offer = this.localPeer.localDescription;
        if (this.whepType === $197a0bf6c144c0fc$export$2351e2e8d1fcfd84.Client && offer) {
            this.log(`Sending offer to ${this.channelUrl}`);
            const response = await fetch(this.channelUrl.toString(), {
                method: "POST",
                headers: {
                    "Content-Type": "application/sdp"
                },
                body: offer.sdp
            });
            if (response.ok) {
                this.resource = this.getResouceUrlFromHeaders(response.headers);
                this.log("WHEP Resource", this.resource);
                const answer = await response.text();
                await this.localPeer.setRemoteDescription({
                    type: "answer",
                    sdp: answer
                });
            } else if (response.status === 400) {
                this.log(`server does not support client-offer, need to reconnect`);
                this.whepType = $197a0bf6c144c0fc$export$2351e2e8d1fcfd84.Server;
                this.onErrorHandler("reconnectneeded");
            } else if (response.status === 406 && this.audio && !this.mediaConstraints.audioOnly && !this.mediaConstraints.videoOnly) {
                this.log(`maybe server does not support audio. Let's retry without audio`);
                this.audio = false;
                this.video = true;
                this.onErrorHandler("reconnectneeded");
            } else if (response.status === 406 && this.video && !this.mediaConstraints.audioOnly && !this.mediaConstraints.videoOnly) {
                this.log(`maybe server does not support video. Let's retry without video`);
                this.audio = true;
                this.video = false;
                this.onErrorHandler("reconnectneeded");
            } else {
                this.error(`sendAnswer response: ${response.status}`);
                this.onErrorHandler("connectionfailed");
            }
        }
    }
    log(...args) {
        if (this.debug) console.log("WebRTC-player", ...args);
    }
    error(...args) {
        console.error("WebRTC-player", ...args);
    }
}


const $c670b344820fffeb$var$WHPPAdapterFactory = (peer, channelUrl, onError, mediaConstraints)=>{
    return new (0, $4eb2d767b36cee6c$export$1bee3ffe1758e87d)(peer, channelUrl, onError);
};
const $c670b344820fffeb$var$EyevinnAdapterFactory = (peer, channelUrl, onError, mediaConstraints)=>{
    return new (0, $2efa4b85661d6410$export$5463baa67f138efa)(peer, channelUrl, onError);
};
const $c670b344820fffeb$var$WHEPAdapterFactory = (peer, channelUrl, onError, mediaConstraints)=>{
    return new (0, $197a0bf6c144c0fc$export$e35e1b35ea68c1)(peer, channelUrl, onError, mediaConstraints);
};
const $c670b344820fffeb$var$adapters = {
    "se.eyevinn.whpp": $c670b344820fffeb$var$WHPPAdapterFactory,
    "se.eyevinn.webrtc": $c670b344820fffeb$var$EyevinnAdapterFactory,
    whep: $c670b344820fffeb$var$WHEPAdapterFactory
};
function $c670b344820fffeb$export$4f24674036ad9ae3(type, peer, channelUrl, onError, mediaConstraints) {
    return $c670b344820fffeb$var$adapters[type](peer, channelUrl, onError, mediaConstraints);
}
function $c670b344820fffeb$export$62ed887aeb7fab64() {
    return Object.keys($c670b344820fffeb$var$adapters);
}


var $a64e4d4dddecbac4$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $a64e4d4dddecbac4$var$R = typeof Reflect === "object" ? Reflect : null;
var $a64e4d4dddecbac4$var$ReflectApply = $a64e4d4dddecbac4$var$R && typeof $a64e4d4dddecbac4$var$R.apply === "function" ? $a64e4d4dddecbac4$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $a64e4d4dddecbac4$var$ReflectOwnKeys;
if ($a64e4d4dddecbac4$var$R && typeof $a64e4d4dddecbac4$var$R.ownKeys === "function") $a64e4d4dddecbac4$var$ReflectOwnKeys = $a64e4d4dddecbac4$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $a64e4d4dddecbac4$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $a64e4d4dddecbac4$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $a64e4d4dddecbac4$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $a64e4d4dddecbac4$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $a64e4d4dddecbac4$var$EventEmitter() {
    $a64e4d4dddecbac4$var$EventEmitter.init.call(this);
}
$a64e4d4dddecbac4$exports = $a64e4d4dddecbac4$var$EventEmitter;
$a64e4d4dddecbac4$exports.once = $a64e4d4dddecbac4$var$once;
// Backwards-compat with node 0.10.x
$a64e4d4dddecbac4$var$EventEmitter.EventEmitter = $a64e4d4dddecbac4$var$EventEmitter;
$a64e4d4dddecbac4$var$EventEmitter.prototype._events = undefined;
$a64e4d4dddecbac4$var$EventEmitter.prototype._eventsCount = 0;
$a64e4d4dddecbac4$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $a64e4d4dddecbac4$var$defaultMaxListeners = 10;
function $a64e4d4dddecbac4$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($a64e4d4dddecbac4$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $a64e4d4dddecbac4$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $a64e4d4dddecbac4$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $a64e4d4dddecbac4$var$defaultMaxListeners = arg;
    }
});
$a64e4d4dddecbac4$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$a64e4d4dddecbac4$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $a64e4d4dddecbac4$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $a64e4d4dddecbac4$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $a64e4d4dddecbac4$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$a64e4d4dddecbac4$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $a64e4d4dddecbac4$var$_getMaxListeners(this);
};
$a64e4d4dddecbac4$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $a64e4d4dddecbac4$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $a64e4d4dddecbac4$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$a64e4d4dddecbac4$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $a64e4d4dddecbac4$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $a64e4d4dddecbac4$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $a64e4d4dddecbac4$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $a64e4d4dddecbac4$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$a64e4d4dddecbac4$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $a64e4d4dddecbac4$var$_addListener(this, type, listener, false);
};
$a64e4d4dddecbac4$var$EventEmitter.prototype.on = $a64e4d4dddecbac4$var$EventEmitter.prototype.addListener;
$a64e4d4dddecbac4$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $a64e4d4dddecbac4$var$_addListener(this, type, listener, true);
};
function $a64e4d4dddecbac4$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $a64e4d4dddecbac4$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $a64e4d4dddecbac4$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$a64e4d4dddecbac4$var$EventEmitter.prototype.once = function once(type, listener) {
    $a64e4d4dddecbac4$var$checkListener(listener);
    this.on(type, $a64e4d4dddecbac4$var$_onceWrap(this, type, listener));
    return this;
};
$a64e4d4dddecbac4$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $a64e4d4dddecbac4$var$checkListener(listener);
    this.prependListener(type, $a64e4d4dddecbac4$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$a64e4d4dddecbac4$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $a64e4d4dddecbac4$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $a64e4d4dddecbac4$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$a64e4d4dddecbac4$var$EventEmitter.prototype.off = $a64e4d4dddecbac4$var$EventEmitter.prototype.removeListener;
$a64e4d4dddecbac4$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $a64e4d4dddecbac4$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $a64e4d4dddecbac4$var$unwrapListeners(evlistener) : $a64e4d4dddecbac4$var$arrayClone(evlistener, evlistener.length);
}
$a64e4d4dddecbac4$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $a64e4d4dddecbac4$var$_listeners(this, type, true);
};
$a64e4d4dddecbac4$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $a64e4d4dddecbac4$var$_listeners(this, type, false);
};
$a64e4d4dddecbac4$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $a64e4d4dddecbac4$var$listenerCount.call(emitter, type);
};
$a64e4d4dddecbac4$var$EventEmitter.prototype.listenerCount = $a64e4d4dddecbac4$var$listenerCount;
function $a64e4d4dddecbac4$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$a64e4d4dddecbac4$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $a64e4d4dddecbac4$var$ReflectOwnKeys(this._events) : [];
};
function $a64e4d4dddecbac4$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $a64e4d4dddecbac4$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $a64e4d4dddecbac4$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $a64e4d4dddecbac4$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $a64e4d4dddecbac4$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $a64e4d4dddecbac4$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $a64e4d4dddecbac4$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $a64e4d4dddecbac4$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $a64e4d4dddecbac4$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $8e77a7afa455b288$exports = {};
var $ceb203e02a2dd5c7$exports = {};
var $ac0f7db8092eb821$exports = {};

$parcel$defineInteropFlag($ac0f7db8092eb821$exports);

$parcel$export($ac0f7db8092eb821$exports, "default", () => $ac0f7db8092eb821$export$2e2bcd8739ae039);
function $ac0f7db8092eb821$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i && i.push(e) || n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && i.splice(i.indexOf(e) >>> 0, 1);
        },
        emit: function(t, e) {
            (n.get(t) || []).slice().map(function(n) {
                n(e);
            }), (n.get("*") || []).slice().map(function(n) {
                n(t, e);
            });
        }
    };
}


function $ceb203e02a2dd5c7$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $ceb203e02a2dd5c7$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$ceb203e02a2dd5c7$var$$parcel$export($ceb203e02a2dd5c7$exports, "VideoEventFilter", ()=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$exports.VideoEventFilter);
$ceb203e02a2dd5c7$var$$parcel$export($ceb203e02a2dd5c7$exports, "PlayerEvents", ()=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$exports.PlayerEvents);
$ceb203e02a2dd5c7$var$$parcel$export($ceb203e02a2dd5c7$exports, "PlayerState", ()=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$exports.PlayerState);
var $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$exports = {};
$ceb203e02a2dd5c7$var$$parcel$export($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$exports, "PlayerState", ()=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509, (v)=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509 = v);
$ceb203e02a2dd5c7$var$$parcel$export($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$exports, "PlayerEvents", ()=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b, (v)=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b = v);
$ceb203e02a2dd5c7$var$$parcel$export($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$exports, "VideoEventFilter", ()=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$68ce463a75cf738d, (v)=>$ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$68ce463a75cf738d = v);
var $ceb203e02a2dd5c7$var$$516c8d13080d4552$export$691d3e4b1045a188 = function() {
    function $516c8d13080d4552$export$691d3e4b1045a188() {
        this.emitter = $ceb203e02a2dd5c7$var$$parcel$interopDefault($ac0f7db8092eb821$exports)();
    }
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.addEventListener = function(event, handler) {
        this.emitter.on.apply(this, [
            event,
            handler
        ]);
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.removeEventListener = function(event, handler) {
        if (this.emitter) this.emitter.off.apply(this, [
            event,
            handler
        ]);
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.clear = function() {
        this.emitter.all.clear();
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.emit = function(event, data) {
        if (this.emitter) this.emitter.emit.apply(this, [
            event,
            data
        ]);
    };
    $516c8d13080d4552$export$691d3e4b1045a188.prototype.destroy = function() {
        this.emitter.all.clear();
        this.emitter = null;
    };
    return $516c8d13080d4552$export$691d3e4b1045a188;
}();
var $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$__extends = function() {
    var extendStatics = function(d1, b1) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d1, b1);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509;
(function($fcdb6cf3608c4662$export$e3425b961a6a8509) {
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Idle"] = "idle";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Loading"] = "loading";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Playing"] = "playing";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Paused"] = "paused";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Buffering"] = "buffering";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Seeking"] = "seeking";
    $fcdb6cf3608c4662$export$e3425b961a6a8509["Ended"] = "ended";
})($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509 || ($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509 = {}));
var $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b;
(function($fcdb6cf3608c4662$export$5013cbcdb4d9878b) {
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Loading"] = "loading";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Loaded"] = "loaded";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Play"] = "play";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Resume"] = "resume";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Pause"] = "pause";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Seeking"] = "seeking";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Seeked"] = "seeked";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Buffering"] = "buffering";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Buffered"] = "buffered";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["TimeUpdate"] = "timeupdate";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Ended"] = "ended";
    $fcdb6cf3608c4662$export$5013cbcdb4d9878b["Error"] = "error";
})($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b || ($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b = {}));
var $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$NetworkState;
(function(NetworkState) {
    NetworkState[NetworkState["NETWORK_EMPTY"] = 0] = "NETWORK_EMPTY";
    NetworkState[NetworkState["NETWORK_IDLE"] = 1] = "NETWORK_IDLE";
    NetworkState[NetworkState["NETWORK_LOADING"] = 2] = "NETWORK_LOADING";
    NetworkState[NetworkState["NETWORK_NO_SOURCE"] = 3] = "NETWORK_NO_SOURCE";
})($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$NetworkState || ($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$NetworkState = {}));
var $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    ReadyState[ReadyState["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    ReadyState[ReadyState["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    ReadyState[ReadyState["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    ReadyState[ReadyState["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$ReadyState || ($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$ReadyState = {}));
function $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$getInitialState(videoElement) {
    if (videoElement.readyState === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$ReadyState.HAVE_NOTHING && videoElement.networkState === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$NetworkState.NETWORK_EMPTY) return $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Idle;
    else if (videoElement.networkState === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$NetworkState.NETWORK_LOADING) return $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading;
    else if (!videoElement.ended) return videoElement.paused ? $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Paused : $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Playing;
    return $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended;
}
var $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$68ce463a75cf738d = function(_super) {
    $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$__extends($fcdb6cf3608c4662$export$68ce463a75cf738d, _super);
    function $fcdb6cf3608c4662$export$68ce463a75cf738d(videoElement) {
        var _this = _super.call(this) || this;
        _this.listeners = [];
        _this.videoElement = videoElement;
        if (typeof videoElement === "string") _this.videoElement = document.querySelector(videoElement);
        _this.state = $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$var$getInitialState(videoElement);
        _this.setupEventListeners();
        return _this;
    }
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.setupEventListeners = function() {
        this.addListener("loadstart", this.onLoading);
        this.addListener("loadeddata", this.onLoaded);
        this.addListener("playing", this.onPlaying);
        this.addListener("pause", this.onPause);
        this.addListener("seeking", this.onSeeking);
        this.addListener("seeked", this.onSeeked);
        this.addListener("waiting", this.onBuffering);
        this.addListener("timeupdate", this.onTimeUpdate);
        this.addListener("error", this.onError);
        this.addListener("ended", this.onEnded);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.addListener = function(type, handler) {
        var boundHandler = handler.bind(this);
        this.videoElement.addEventListener(type, boundHandler);
        this.listeners.push({
            type: type,
            handler: boundHandler
        });
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onLoading = function() {
        if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading) return;
        this.setState($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading);
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Loading);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onLoaded = function() {
        if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading) this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Loaded);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onPlaying = function() {
        if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended) this.setState($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading);
        if ([
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Paused
        ].includes(this.state)) {
            if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading) this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Play);
            if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Paused) {
                this.lastState = $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Paused;
                this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Resume);
            }
            this.setState($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Playing, true);
        }
        if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering) this.onBuffered();
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onPause = function() {
        var _this = this;
        if (this.state !== $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Playing) return;
        clearTimeout(this.pauseDebounce);
        this.pauseDebounce = window.setTimeout(function() {
            _this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Pause);
            _this.setState($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Paused, true);
        }, 200);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onSeeking = function() {
        if ([
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended
        ].includes(this.state)) return;
        clearTimeout(this.pauseDebounce);
        this.setState($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking, true);
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Seeking);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onSeeked = function() {
        if (this.state !== $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking) return;
        this.setState(this.lastState, true);
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Seeked);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onBuffering = function() {
        if ([
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended
        ].includes(this.state)) return;
        this.setState($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering, true);
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Buffering);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onBuffered = function() {
        if (this.state !== $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering) return;
        this.setState(this.lastState, true);
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Buffered);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onTimeUpdate = function() {
        if (this.videoElement.seeking || [
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Loading,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Paused,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Seeking,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Buffering,
            $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended
        ].includes(this.state)) return;
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.TimeUpdate);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onEnded = function() {
        clearTimeout(this.pauseDebounce);
        if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended) return;
        this.setState($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended);
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Ended);
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.onError = function() {
        if (this.state === $ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$e3425b961a6a8509.Ended) return;
        this.emit($ceb203e02a2dd5c7$var$$fcdb6cf3608c4662$export$5013cbcdb4d9878b.Error, this.videoElement.error);
        this.onEnded();
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.getState = function() {
        return this.state;
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.setState = function(state, updateLast) {
        if (updateLast) this.updateLastState(this.state);
        this.state = state;
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.updateLastState = function(state) {
        if (state) this.lastState = state;
        else this.lastState = this.state;
    };
    $fcdb6cf3608c4662$export$68ce463a75cf738d.prototype.destroy = function() {
        var _this = this;
        this.listeners.forEach(function(_a) {
            var type = _a.type, handler = _a.handler;
            _this.videoElement.removeEventListener(type, handler);
        });
        _super.prototype.destroy.call(this);
    };
    return $fcdb6cf3608c4662$export$68ce463a75cf738d;
}($ceb203e02a2dd5c7$var$$516c8d13080d4552$export$691d3e4b1045a188);


var $b92673c9958612fb$exports = {};
!function(e, t) {
    t($b92673c9958612fb$exports);
}($b92673c9958612fb$exports, function(e) {
    "use strict";
    function t(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            t && (i = i.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, i);
        }
        return r;
    }
    function r(e) {
        for(var r = 1; r < arguments.length; r++){
            var i = null != arguments[r] ? arguments[r] : {};
            r % 2 ? t(Object(i), !0).forEach(function(t) {
                s(e, t, i[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
            });
        }
        return e;
    }
    function i(e) {
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, i(e);
    }
    function n(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function a(e, t) {
        for(var r = 0; r < t.length; r++){
            var i = t[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
        }
    }
    function o(e, t, r) {
        return t && a(e.prototype, t), r && a(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function s(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && c(e, t);
    }
    function u(e) {
        return u = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, u(e);
    }
    function c(e, t) {
        return c = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        }, c(e, t);
    }
    function d(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }(e);
    }
    function p(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, i = u(e);
            if (t) {
                var n = u(this).constructor;
                r = Reflect.construct(i, arguments, n);
            } else r = i.apply(this, arguments);
            return d(this, r);
        };
    }
    function h(e) {
        return function(e) {
            if (Array.isArray(e)) return v(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return v(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return v(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function v(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, i = new Array(t); r < t; r++)i[r] = e[r];
        return i;
    }
    function f() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return {
            id: e.id || null,
            adId: e.adId || null,
            sequence: e.sequence || null,
            apiFramework: e.apiFramework || null,
            universalAdIds: [],
            creativeExtensions: []
        };
    }
    var m = [
        "ADCATEGORIES",
        "ADCOUNT",
        "ADPLAYHEAD",
        "ADSERVINGID",
        "ADTYPE",
        "APIFRAMEWORKS",
        "APPBUNDLE",
        "ASSETURI",
        "BLOCKEDADCATEGORIES",
        "BREAKMAXADLENGTH",
        "BREAKMAXADS",
        "BREAKMAXDURATION",
        "BREAKMINADLENGTH",
        "BREAKMINDURATION",
        "BREAKPOSITION",
        "CLICKPOS",
        "CLICKTYPE",
        "CLIENTUA",
        "CONTENTID",
        "CONTENTPLAYHEAD",
        "CONTENTURI",
        "DEVICEIP",
        "DEVICEUA",
        "DOMAIN",
        "EXTENSIONS",
        "GDPRCONSENT",
        "IFA",
        "IFATYPE",
        "INVENTORYSTATE",
        "LATLONG",
        "LIMITADTRACKING",
        "MEDIAMIME",
        "MEDIAPLAYHEAD",
        "OMIDPARTNER",
        "PAGEURL",
        "PLACEMENTTYPE",
        "PLAYERCAPABILITIES",
        "PLAYERSIZE",
        "PLAYERSTATE",
        "PODSEQUENCE",
        "REGULATIONS",
        "SERVERSIDE",
        "SERVERUA",
        "TRANSACTIONID",
        "UNIVERSALADID",
        "VASTVERSIONS",
        "VERIFICATIONVENDORS"
    ];
    function g(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = [], n = A(e);
        for(var a in !t.ERRORCODE || r.isCustomCode || /^[0-9]{3}$/.test(t.ERRORCODE) || (t.ERRORCODE = 900), t.CACHEBUSTING = E(Math.round(1e8 * Math.random()).toString()), t.TIMESTAMP = (new Date).toISOString(), t.RANDOM = t.random = t.CACHEBUSTING, t)t[a] = b(t[a]);
        for(var o in n){
            var s = n[o];
            "string" == typeof s && i.push(T(s, t));
        }
        return i;
    }
    function T(e, t) {
        var r = (e = y(e, t)).match(/[^[\]]+(?=])/g);
        if (!r) return e;
        var i = r.filter(function(e) {
            return m.indexOf(e) > -1;
        });
        return 0 === i.length ? e : y(e, i = i.reduce(function(e, t) {
            return e[t] = -1, e;
        }, {}));
    }
    function y(e, t) {
        var r = e;
        for(var i in t){
            var n = t[i];
            r = r.replace(new RegExp("(?:\\[|%%)(".concat(i, ")(?:\\]|%%)"), "g"), n);
        }
        return r;
    }
    function A(e) {
        return Array.isArray(e) ? e.map(function(e) {
            return e && e.hasOwnProperty("url") ? e.url : e;
        }) : e;
    }
    function k(e, t) {
        for(var r = 0; r < t.length; r++)if (R(t[r], e)) return !0;
        return !1;
    }
    function R(e, t) {
        if (e && t) {
            var r = Object.getOwnPropertyNames(e), i = Object.getOwnPropertyNames(t);
            return r.length === i.length && e.id === t.id && e.url === t.url;
        }
        return !1;
    }
    function b(e) {
        return encodeURIComponent(e).replace(/[!'()*]/g, function(e) {
            return "%".concat(e.charCodeAt(0).toString(16));
        });
    }
    function E(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8, r = String(e);
        return r.length < t ? N(0, t - r.length, !1).map(function() {
            return "0";
        }).join("") + r : r;
    }
    function N(e, t, r) {
        for(var i = [], n = e < t, a = r ? n ? t + 1 : t - 1 : t, o = e; n ? o < a : o > a; n ? o++ : o--)i.push(o);
        return i;
    }
    var L = {
        track: function(e, t, r) {
            g(e, t, r).forEach(function(e) {
                "undefined" != typeof window && null !== window && ((new Image).src = e);
            });
        },
        resolveURLTemplates: g,
        extractURLsFromTemplates: A,
        containsTemplateObject: k,
        isTemplateObjectEqual: R,
        encodeURIComponentRFC3986: b,
        replaceUrlMacros: T,
        leftpad: E,
        range: N,
        isNumeric: function(e) {
            return !isNaN(parseFloat(e)) && isFinite(e);
        },
        flatten: function e(t) {
            return t.reduce(function(t, r) {
                return t.concat(Array.isArray(r) ? e(r) : r);
            }, []);
        },
        joinArrayOfUniqueTemplateObjs: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = Array.isArray(e) ? e : [], i = Array.isArray(t) ? t : [], n = r.concat(i);
            return n.reduce(function(e, t) {
                return k(t, e) || e.push(t), e;
            }, []);
        }
    };
    function w(e) {
        return -1 !== [
            "true",
            "TRUE",
            "True",
            "1"
        ].indexOf(e);
    }
    var U = {
        childByName: function(e, t) {
            var r = e.childNodes;
            for(var i in r){
                var n = r[i];
                if (n.nodeName === t) return n;
            }
        },
        childrenByName: function(e, t) {
            var r = [], i = e.childNodes;
            for(var n in i){
                var a = i[n];
                a.nodeName === t && r.push(a);
            }
            return r;
        },
        resolveVastAdTagURI: function(e, t) {
            if (!t) return e;
            if (0 === e.indexOf("//")) {
                var r = location.protocol;
                return "".concat(r).concat(e);
            }
            if (-1 === e.indexOf("://")) {
                var i = t.slice(0, t.lastIndexOf("/"));
                return "".concat(i, "/").concat(e);
            }
            return e;
        },
        parseBoolean: w,
        parseNodeText: function(e) {
            return e && (e.textContent || e.text || "").trim();
        },
        copyNodeAttribute: function(e, t, r) {
            var i = t.getAttribute(e);
            i && r.setAttribute(e, i);
        },
        parseAttributes: function(e) {
            for(var t = e.attributes, r = {}, i = 0; i < t.length; i++)r[t[i].nodeName] = t[i].nodeValue;
            return r;
        },
        parseDuration: function(e) {
            if (null == e) return -1;
            if (L.isNumeric(e)) return parseInt(e);
            var t = e.split(":");
            if (3 !== t.length) return -1;
            var r = t[2].split("."), i = parseInt(r[0]);
            2 === r.length && (i += parseFloat("0.".concat(r[1])));
            var n = parseInt(60 * t[1]), a = parseInt(60 * t[0] * 60);
            return isNaN(a) || isNaN(n) || isNaN(i) || n > 3600 || i > 60 ? -1 : a + n + i;
        },
        splitVAST: function(e) {
            var t = [], r = null;
            return e.forEach(function(i, n) {
                if (i.sequence && (i.sequence = parseInt(i.sequence, 10)), i.sequence > 1) {
                    var a = e[n - 1];
                    if (a && a.sequence === i.sequence - 1) return void (r && r.push(i));
                    delete i.sequence;
                }
                r = [
                    i
                ], t.push(r);
            }), t;
        },
        assignAttributes: function(e, t) {
            if (e) for(var r in e){
                var i = e[r];
                if (i.nodeName && i.nodeValue && t.hasOwnProperty(i.nodeName)) {
                    var n = i.nodeValue;
                    "boolean" == typeof t[i.nodeName] && (n = w(n)), t[i.nodeName] = n;
                }
            }
        },
        mergeWrapperAdData: function(e, t) {
            e.errorURLTemplates = t.errorURLTemplates.concat(e.errorURLTemplates), e.impressionURLTemplates = t.impressionURLTemplates.concat(e.impressionURLTemplates), e.extensions = t.extensions.concat(e.extensions), t.viewableImpression.length > 0 && (e.viewableImpression = [].concat(h(e.viewableImpression), h(t.viewableImpression))), e.followAdditionalWrappers = t.followAdditionalWrappers, e.allowMultipleAds = t.allowMultipleAds, e.fallbackOnNoAd = t.fallbackOnNoAd;
            var r = (t.creatives || []).filter(function(e) {
                return e && "companion" === e.type;
            }), i = r.reduce(function(e, t) {
                return (t.variations || []).forEach(function(t) {
                    (t.companionClickTrackingURLTemplates || []).forEach(function(t) {
                        L.containsTemplateObject(t, e) || e.push(t);
                    });
                }), e;
            }, []);
            e.creatives = r.concat(e.creatives);
            var n = t.videoClickTrackingURLTemplates && t.videoClickTrackingURLTemplates.length, a = t.videoCustomClickURLTemplates && t.videoCustomClickURLTemplates.length;
            e.creatives.forEach(function(e) {
                if (t.trackingEvents && t.trackingEvents[e.type]) for(var r in t.trackingEvents[e.type]){
                    var o = t.trackingEvents[e.type][r];
                    Array.isArray(e.trackingEvents[r]) || (e.trackingEvents[r] = []), e.trackingEvents[r] = e.trackingEvents[r].concat(o);
                }
                "linear" === e.type && (n && (e.videoClickTrackingURLTemplates = e.videoClickTrackingURLTemplates.concat(t.videoClickTrackingURLTemplates)), a && (e.videoCustomClickURLTemplates = e.videoCustomClickURLTemplates.concat(t.videoCustomClickURLTemplates)), !t.videoClickThroughURLTemplate || null !== e.videoClickThroughURLTemplate && void 0 !== e.videoClickThroughURLTemplate || (e.videoClickThroughURLTemplate = t.videoClickThroughURLTemplate)), "companion" === e.type && i.length && (e.variations || []).forEach(function(e) {
                    e.companionClickTrackingURLTemplates = L.joinArrayOfUniqueTemplateObjs(e.companionClickTrackingURLTemplates, i);
                });
            }), t.adVerifications && (e.adVerifications = e.adVerifications.concat(t.adVerifications)), t.blockedAdCategories && (e.blockedAdCategories = e.blockedAdCategories.concat(t.blockedAdCategories));
        }
    };
    function C(e, t) {
        var r = function() {
            var e = f(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), t = e.id, r = e.adId, i = e.sequence, n = e.apiFramework;
            return {
                id: t,
                adId: r,
                sequence: i,
                apiFramework: n,
                type: "companion",
                required: null,
                variations: []
            };
        }(t);
        return r.required = e.getAttribute("required") || null, r.variations = U.childrenByName(e, "Companion").map(function(e) {
            var t = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return {
                    id: e.id || null,
                    adType: "companionAd",
                    width: e.width || 0,
                    height: e.height || 0,
                    assetWidth: e.assetWidth || null,
                    assetHeight: e.assetHeight || null,
                    expandedWidth: e.expandedWidth || null,
                    expandedHeight: e.expandedHeight || null,
                    apiFramework: e.apiFramework || null,
                    adSlotID: e.adSlotID || null,
                    pxratio: e.pxratio || "1",
                    renderingMode: e.renderingMode || "default",
                    staticResources: [],
                    htmlResources: [],
                    iframeResources: [],
                    adParameters: null,
                    xmlEncoded: null,
                    altText: null,
                    companionClickThroughURLTemplate: null,
                    companionClickTrackingURLTemplates: [],
                    trackingEvents: {}
                };
            }(U.parseAttributes(e));
            t.htmlResources = U.childrenByName(e, "HTMLResource").reduce(function(e, t) {
                var r = U.parseNodeText(t);
                return r ? e.concat(r) : e;
            }, []), t.iframeResources = U.childrenByName(e, "IFrameResource").reduce(function(e, t) {
                var r = U.parseNodeText(t);
                return r ? e.concat(r) : e;
            }, []), t.staticResources = U.childrenByName(e, "StaticResource").reduce(function(e, t) {
                var r = U.parseNodeText(t);
                return r ? e.concat({
                    url: r,
                    creativeType: t.getAttribute("creativeType") || null
                }) : e;
            }, []), t.altText = U.parseNodeText(U.childByName(e, "AltText")) || null;
            var r = U.childByName(e, "TrackingEvents");
            r && U.childrenByName(r, "Tracking").forEach(function(e) {
                var r = e.getAttribute("event"), i = U.parseNodeText(e);
                r && i && (Array.isArray(t.trackingEvents[r]) || (t.trackingEvents[r] = []), t.trackingEvents[r].push(i));
            }), t.companionClickTrackingURLTemplates = U.childrenByName(e, "CompanionClickTracking").map(function(e) {
                return {
                    id: e.getAttribute("id") || null,
                    url: U.parseNodeText(e)
                };
            }), t.companionClickThroughURLTemplate = U.parseNodeText(U.childByName(e, "CompanionClickThrough")) || null;
            var i = U.childByName(e, "AdParameters");
            return i && (t.adParameters = U.parseNodeText(i), t.xmlEncoded = i.getAttribute("xmlEncoded") || null), t;
        }), r;
    }
    function I(e) {
        return "linear" === e.type;
    }
    function x(e, t) {
        var r, i = function() {
            var e = f(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), t = e.id, r = e.adId, i = e.sequence, n = e.apiFramework;
            return {
                id: t,
                adId: r,
                sequence: i,
                apiFramework: n,
                type: "linear",
                duration: 0,
                skipDelay: null,
                mediaFiles: [],
                mezzanine: null,
                interactiveCreativeFile: null,
                closedCaptionFiles: [],
                videoClickThroughURLTemplate: null,
                videoClickTrackingURLTemplates: [],
                videoCustomClickURLTemplates: [],
                adParameters: null,
                icons: [],
                trackingEvents: {}
            };
        }(t);
        i.duration = U.parseDuration(U.parseNodeText(U.childByName(e, "Duration")));
        var n = e.getAttribute("skipoffset");
        if (null == n) i.skipDelay = null;
        else if ("%" === n.charAt(n.length - 1) && -1 !== i.duration) {
            var a = parseInt(n, 10);
            i.skipDelay = i.duration * (a / 100);
        } else i.skipDelay = U.parseDuration(n);
        var o = U.childByName(e, "VideoClicks");
        if (o) {
            var s = U.childByName(o, "ClickThrough");
            i.videoClickThroughURLTemplate = s ? {
                id: s.getAttribute("id") || null,
                url: U.parseNodeText(s)
            } : null, U.childrenByName(o, "ClickTracking").forEach(function(e) {
                i.videoClickTrackingURLTemplates.push({
                    id: e.getAttribute("id") || null,
                    url: U.parseNodeText(e)
                });
            }), U.childrenByName(o, "CustomClick").forEach(function(e) {
                i.videoCustomClickURLTemplates.push({
                    id: e.getAttribute("id") || null,
                    url: U.parseNodeText(e)
                });
            });
        }
        var l = U.childByName(e, "AdParameters");
        l && (i.adParameters = U.parseNodeText(l)), U.childrenByName(e, "TrackingEvents").forEach(function(e) {
            U.childrenByName(e, "Tracking").forEach(function(e) {
                var t = e.getAttribute("event"), n = U.parseNodeText(e);
                if (t && n) {
                    if ("progress" === t) {
                        if (!(r = e.getAttribute("offset"))) return;
                        t = "%" === r.charAt(r.length - 1) ? "progress-".concat(r) : "progress-".concat(Math.round(U.parseDuration(r)));
                    }
                    Array.isArray(i.trackingEvents[t]) || (i.trackingEvents[t] = []), i.trackingEvents[t].push(n);
                }
            });
        }), U.childrenByName(e, "MediaFiles").forEach(function(e) {
            U.childrenByName(e, "MediaFile").forEach(function(e) {
                i.mediaFiles.push(function(e) {
                    var t = {
                        id: null,
                        fileURL: null,
                        fileSize: 0,
                        deliveryType: "progressive",
                        mimeType: null,
                        mediaType: null,
                        codec: null,
                        bitrate: 0,
                        minBitrate: 0,
                        maxBitrate: 0,
                        width: 0,
                        height: 0,
                        apiFramework: null,
                        scalable: null,
                        maintainAspectRatio: null
                    };
                    t.id = e.getAttribute("id"), t.fileURL = U.parseNodeText(e), t.deliveryType = e.getAttribute("delivery"), t.codec = e.getAttribute("codec"), t.mimeType = e.getAttribute("type"), t.mediaType = e.getAttribute("mediaType") || "2D", t.apiFramework = e.getAttribute("apiFramework"), t.fileSize = parseInt(e.getAttribute("fileSize") || 0), t.bitrate = parseInt(e.getAttribute("bitrate") || 0), t.minBitrate = parseInt(e.getAttribute("minBitrate") || 0), t.maxBitrate = parseInt(e.getAttribute("maxBitrate") || 0), t.width = parseInt(e.getAttribute("width") || 0), t.height = parseInt(e.getAttribute("height") || 0);
                    var r = e.getAttribute("scalable");
                    r && "string" == typeof r && (t.scalable = U.parseBoolean(r));
                    var i = e.getAttribute("maintainAspectRatio");
                    i && "string" == typeof i && (t.maintainAspectRatio = U.parseBoolean(i));
                    return t;
                }(e));
            });
            var t = U.childByName(e, "InteractiveCreativeFile");
            t && (i.interactiveCreativeFile = function(e) {
                var t = function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return {
                        type: e.type || null,
                        apiFramework: e.apiFramework || null,
                        variableDuration: U.parseBoolean(e.variableDuration),
                        fileURL: null
                    };
                }(U.parseAttributes(e));
                return t.fileURL = U.parseNodeText(e), t;
            }(t));
            var r = U.childByName(e, "ClosedCaptionFiles");
            r && U.childrenByName(r, "ClosedCaptionFile").forEach(function(e) {
                var t = function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return {
                        type: e.type || null,
                        language: e.language || null,
                        fileURL: null
                    };
                }(U.parseAttributes(e));
                t.fileURL = U.parseNodeText(e), i.closedCaptionFiles.push(t);
            });
            var n, a, o, s = U.childByName(e, "Mezzanine"), l = (n = s, a = {}, o = !1, [
                "delivery",
                "type",
                "width",
                "height"
            ].forEach(function(e) {
                n && n.getAttribute(e) ? a[e] = n.getAttribute(e) : o = !0;
            }), o ? null : a);
            if (l) {
                var u = {
                    id: null,
                    fileURL: null,
                    delivery: null,
                    codec: null,
                    type: null,
                    width: 0,
                    height: 0,
                    fileSize: 0,
                    mediaType: "2D"
                };
                u.id = s.getAttribute("id"), u.fileURL = U.parseNodeText(s), u.delivery = l.delivery, u.codec = s.getAttribute("codec"), u.type = l.type, u.width = parseInt(l.width, 10), u.height = parseInt(l.height, 10), u.fileSize = parseInt(s.getAttribute("fileSize"), 10), u.mediaType = s.getAttribute("mediaType") || "2D", i.mezzanine = u;
            }
        });
        var u = U.childByName(e, "Icons");
        return u && U.childrenByName(u, "Icon").forEach(function(e) {
            i.icons.push(function(e) {
                var t = {
                    program: null,
                    height: 0,
                    width: 0,
                    xPosition: 0,
                    yPosition: 0,
                    apiFramework: null,
                    offset: null,
                    duration: 0,
                    type: null,
                    staticResource: null,
                    htmlResource: null,
                    iframeResource: null,
                    pxratio: "1",
                    iconClickThroughURLTemplate: null,
                    iconClickTrackingURLTemplates: [],
                    iconViewTrackingURLTemplate: null
                };
                t.program = e.getAttribute("program"), t.height = parseInt(e.getAttribute("height") || 0), t.width = parseInt(e.getAttribute("width") || 0), t.xPosition = function(e) {
                    if (-1 !== [
                        "left",
                        "right"
                    ].indexOf(e)) return e;
                    return parseInt(e || 0);
                }(e.getAttribute("xPosition")), t.yPosition = function(e) {
                    if (-1 !== [
                        "top",
                        "bottom"
                    ].indexOf(e)) return e;
                    return parseInt(e || 0);
                }(e.getAttribute("yPosition")), t.apiFramework = e.getAttribute("apiFramework"), t.pxratio = e.getAttribute("pxratio") || "1", t.offset = U.parseDuration(e.getAttribute("offset")), t.duration = U.parseDuration(e.getAttribute("duration")), U.childrenByName(e, "HTMLResource").forEach(function(e) {
                    t.type = e.getAttribute("creativeType") || "text/html", t.htmlResource = U.parseNodeText(e);
                }), U.childrenByName(e, "IFrameResource").forEach(function(e) {
                    t.type = e.getAttribute("creativeType") || 0, t.iframeResource = U.parseNodeText(e);
                }), U.childrenByName(e, "StaticResource").forEach(function(e) {
                    t.type = e.getAttribute("creativeType") || 0, t.staticResource = U.parseNodeText(e);
                });
                var r = U.childByName(e, "IconClicks");
                r && (t.iconClickThroughURLTemplate = U.parseNodeText(U.childByName(r, "IconClickThrough")), U.childrenByName(r, "IconClickTracking").forEach(function(e) {
                    t.iconClickTrackingURLTemplates.push({
                        id: e.getAttribute("id") || null,
                        url: U.parseNodeText(e)
                    });
                }));
                return t.iconViewTrackingURLTemplate = U.parseNodeText(U.childByName(e, "IconViewTracking")), t;
            }(e));
        }), i;
    }
    function S(e, t) {
        var r = function() {
            var e = f(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), t = e.id, r = e.adId, i = e.sequence, n = e.apiFramework;
            return {
                id: t,
                adId: r,
                sequence: i,
                apiFramework: n,
                type: "nonlinear",
                variations: [],
                trackingEvents: {}
            };
        }(t);
        return U.childrenByName(e, "TrackingEvents").forEach(function(e) {
            var t, i;
            U.childrenByName(e, "Tracking").forEach(function(e) {
                t = e.getAttribute("event"), i = U.parseNodeText(e), t && i && (Array.isArray(r.trackingEvents[t]) || (r.trackingEvents[t] = []), r.trackingEvents[t].push(i));
            });
        }), U.childrenByName(e, "NonLinear").forEach(function(e) {
            var t = {
                id: null,
                width: 0,
                height: 0,
                expandedWidth: 0,
                expandedHeight: 0,
                scalable: !0,
                maintainAspectRatio: !0,
                minSuggestedDuration: 0,
                apiFramework: "static",
                adType: "nonLinearAd",
                type: null,
                staticResource: null,
                htmlResource: null,
                iframeResource: null,
                nonlinearClickThroughURLTemplate: null,
                nonlinearClickTrackingURLTemplates: [],
                adParameters: null
            };
            t.id = e.getAttribute("id") || null, t.width = e.getAttribute("width"), t.height = e.getAttribute("height"), t.expandedWidth = e.getAttribute("expandedWidth"), t.expandedHeight = e.getAttribute("expandedHeight"), t.scalable = U.parseBoolean(e.getAttribute("scalable")), t.maintainAspectRatio = U.parseBoolean(e.getAttribute("maintainAspectRatio")), t.minSuggestedDuration = U.parseDuration(e.getAttribute("minSuggestedDuration")), t.apiFramework = e.getAttribute("apiFramework"), U.childrenByName(e, "HTMLResource").forEach(function(e) {
                t.type = e.getAttribute("creativeType") || "text/html", t.htmlResource = U.parseNodeText(e);
            }), U.childrenByName(e, "IFrameResource").forEach(function(e) {
                t.type = e.getAttribute("creativeType") || 0, t.iframeResource = U.parseNodeText(e);
            }), U.childrenByName(e, "StaticResource").forEach(function(e) {
                t.type = e.getAttribute("creativeType") || 0, t.staticResource = U.parseNodeText(e);
            });
            var i = U.childByName(e, "AdParameters");
            i && (t.adParameters = U.parseNodeText(i)), t.nonlinearClickThroughURLTemplate = U.parseNodeText(U.childByName(e, "NonLinearClickThrough")), U.childrenByName(e, "NonLinearClickTracking").forEach(function(e) {
                t.nonlinearClickTrackingURLTemplates.push({
                    id: e.getAttribute("id") || null,
                    url: U.parseNodeText(e)
                });
            }), r.variations.push(t);
        }), r;
    }
    function O(e) {
        var t = [];
        return e.forEach(function(e) {
            var r = D(e);
            r && t.push(r);
        }), t;
    }
    function D(e) {
        if ("#comment" === e.nodeName) return null;
        var t, r = {
            name: null,
            value: null,
            attributes: {},
            children: []
        }, i = e.attributes, n = e.childNodes;
        if (r.name = e.nodeName, e.attributes) {
            for(var a in i)if (i.hasOwnProperty(a)) {
                var o = i[a];
                o.nodeName && o.nodeValue && (r.attributes[o.nodeName] = o.nodeValue);
            }
        }
        for(var s in n)if (n.hasOwnProperty(s)) {
            var l = D(n[s]);
            l && r.children.push(l);
        }
        if (0 === r.children.length || 1 === r.children.length && [
            "#cdata-section",
            "#text"
        ].indexOf(r.children[0].name) >= 0) {
            var u = U.parseNodeText(e);
            "" !== u && (r.value = u), r.children = [];
        }
        return null === (t = r).value && 0 === Object.keys(t.attributes).length && 0 === t.children.length ? null : r;
    }
    function V(e) {
        var t = [];
        return e.forEach(function(e) {
            var r, i = {
                id: e.getAttribute("id") || null,
                adId: P(e),
                sequence: e.getAttribute("sequence") || null,
                apiFramework: e.getAttribute("apiFramework") || null
            }, n = [];
            U.childrenByName(e, "UniversalAdId").forEach(function(e) {
                var t = {
                    idRegistry: e.getAttribute("idRegistry") || "unknown",
                    value: U.parseNodeText(e)
                };
                n.push(t);
            });
            var a = U.childByName(e, "CreativeExtensions");
            for(var o in a && (r = O(U.childrenByName(a, "CreativeExtension"))), e.childNodes){
                var s = e.childNodes[o], l = void 0;
                switch(s.nodeName){
                    case "Linear":
                        l = x(s, i);
                        break;
                    case "NonLinearAds":
                        l = S(s, i);
                        break;
                    case "CompanionAds":
                        l = C(s, i);
                }
                l && (n && (l.universalAdIds = n), r && (l.creativeExtensions = r), t.push(l));
            }
        }), t;
    }
    function P(e) {
        return e.getAttribute("AdID") || e.getAttribute("adID") || e.getAttribute("adId") || null;
    }
    var B = {
        Wrapper: {
            subElements: [
                "VASTAdTagURI",
                "Impression"
            ]
        },
        BlockedAdCategories: {
            attributes: [
                "authority"
            ]
        },
        InLine: {
            subElements: [
                "AdSystem",
                "AdTitle",
                "Impression",
                "AdServingId",
                "Creatives"
            ]
        },
        Category: {
            attributes: [
                "authority"
            ]
        },
        Pricing: {
            attributes: [
                "model",
                "currency"
            ]
        },
        Verification: {
            oneOfinLineResources: [
                "JavaScriptResource",
                "ExecutableResource"
            ],
            attributes: [
                "vendor"
            ]
        },
        UniversalAdId: {
            attributes: [
                "idRegistry"
            ]
        },
        JavaScriptResource: {
            attributes: [
                "apiFramework",
                "browserOptional"
            ]
        },
        ExecutableResource: {
            attributes: [
                "apiFramework",
                "type"
            ]
        },
        Tracking: {
            attributes: [
                "event"
            ]
        },
        Creatives: {
            subElements: [
                "Creative"
            ]
        },
        Creative: {
            subElements: [
                "UniversalAdId"
            ]
        },
        Linear: {
            subElements: [
                "MediaFiles",
                "Duration"
            ]
        },
        MediaFiles: {
            subElements: [
                "MediaFile"
            ]
        },
        MediaFile: {
            attributes: [
                "delivery",
                "type",
                "width",
                "height"
            ]
        },
        Mezzanine: {
            attributes: [
                "delivery",
                "type",
                "width",
                "height"
            ]
        },
        NonLinear: {
            oneOfinLineResources: [
                "StaticResource",
                "IFrameResource",
                "HTMLResource"
            ],
            attributes: [
                "width",
                "height"
            ]
        },
        Companion: {
            oneOfinLineResources: [
                "StaticResource",
                "IFrameResource",
                "HTMLResource"
            ],
            attributes: [
                "width",
                "height"
            ]
        },
        StaticResource: {
            attributes: [
                "creativeType"
            ]
        },
        Icons: {
            subElements: [
                "Icon"
            ]
        },
        Icon: {
            oneOfinLineResources: [
                "StaticResource",
                "IFrameResource",
                "HTMLResource"
            ]
        }
    };
    function F(e, t) {
        if (B[e.nodeName] && B[e.nodeName].attributes) {
            var r = B[e.nodeName].attributes.filter(function(t) {
                return !e.getAttribute(t);
            });
            r.length > 0 && j({
                name: e.nodeName,
                parentName: e.parentNode.nodeName,
                attributes: r
            }, t);
        }
    }
    function M(e, t, r) {
        var i = B[e.nodeName], n = !r && "Wrapper" !== e.nodeName;
        if (i && !n) {
            if (i.subElements) {
                var a = i.subElements.filter(function(t) {
                    return !U.childByName(e, t);
                });
                a.length > 0 && j({
                    name: e.nodeName,
                    parentName: e.parentNode.nodeName,
                    subElements: a
                }, t);
            }
            if (r && i.oneOfinLineResources) i.oneOfinLineResources.some(function(t) {
                return U.childByName(e, t);
            }) || j({
                name: e.nodeName,
                parentName: e.parentNode.nodeName,
                oneOfResources: i.oneOfinLineResources
            }, t);
        }
    }
    function W(e) {
        return e.children && 0 !== e.children.length;
    }
    function j(e, t) {
        var r = e.name, i = e.parentName, n = e.attributes, a = e.subElements, o = e.oneOfResources, s = "Element '".concat(r, "'");
        t("VAST-warning", {
            message: s += n ? " missing required attribute(s) '".concat(n.join(", "), "' ") : a ? " missing required sub element(s) '".concat(a.join(", "), "' ") : o ? " must provide one of the following '".concat(o.join(", "), "' ") : " is empty",
            parentElement: i,
            specVersion: 4.1
        });
    }
    var q = {
        verifyRequiredValues: function e(t, r, i) {
            if (t && t.nodeName) {
                if ("InLine" === t.nodeName && (i = !0), F(t, r), W(t)) {
                    M(t, r, i);
                    for(var n = 0; n < t.children.length; n++)e(t.children[n], r, i);
                } else 0 === U.parseNodeText(t).length && j({
                    name: t.nodeName,
                    parentName: t.parentNode.nodeName
                }, r);
            }
        },
        hasSubElements: W,
        emitMissingValueWarning: j,
        verifyRequiredAttributes: F,
        verifyRequiredSubElements: M
    };
    function H(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = r.allowMultipleAds, n = r.followAdditionalWrappers, a = e.childNodes;
        for(var o in a){
            var s = a[o];
            if (-1 !== [
                "Wrapper",
                "InLine"
            ].indexOf(s.nodeName) && ("Wrapper" !== s.nodeName || !1 !== n)) {
                if (U.copyNodeAttribute("id", e, s), U.copyNodeAttribute("sequence", e, s), U.copyNodeAttribute("adType", e, s), "Wrapper" === s.nodeName) return {
                    ad: z(s, t),
                    type: "WRAPPER"
                };
                if ("InLine" === s.nodeName) return {
                    ad: _(s, t, {
                        allowMultipleAds: i
                    }),
                    type: "INLINE"
                };
            }
        }
    }
    function _(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = r.allowMultipleAds;
        return !1 === i && e.getAttribute("sequence") ? null : G(e, t);
    }
    function G(e, t) {
        var r = [];
        t && q.verifyRequiredValues(e, t);
        var i = e.childNodes, n = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return {
                id: e.id || null,
                sequence: e.sequence || null,
                adType: e.adType || null,
                adServingId: null,
                categories: [],
                expires: null,
                viewableImpression: [],
                system: null,
                title: null,
                description: null,
                advertiser: null,
                pricing: null,
                survey: null,
                errorURLTemplates: [],
                impressionURLTemplates: [],
                creatives: [],
                extensions: [],
                adVerifications: [],
                blockedAdCategories: [],
                followAdditionalWrappers: !0,
                allowMultipleAds: !1,
                fallbackOnNoAd: null
            };
        }(U.parseAttributes(e));
        for(var a in i){
            var o = i[a];
            switch(o.nodeName){
                case "Error":
                    n.errorURLTemplates.push(U.parseNodeText(o));
                    break;
                case "Impression":
                    n.impressionURLTemplates.push({
                        id: o.getAttribute("id") || null,
                        url: U.parseNodeText(o)
                    });
                    break;
                case "Creatives":
                    n.creatives = V(U.childrenByName(o, "Creative"));
                    break;
                case "Extensions":
                    var s = U.childrenByName(o, "Extension");
                    n.extensions = O(s), n.adVerifications.length || (r = X(s));
                    break;
                case "AdVerifications":
                    n.adVerifications = Y(U.childrenByName(o, "Verification"));
                    break;
                case "AdSystem":
                    n.system = {
                        value: U.parseNodeText(o),
                        version: o.getAttribute("version") || null
                    };
                    break;
                case "AdTitle":
                    n.title = U.parseNodeText(o);
                    break;
                case "AdServingId":
                    n.adServingId = U.parseNodeText(o);
                    break;
                case "Category":
                    n.categories.push({
                        authority: o.getAttribute("authority") || null,
                        value: U.parseNodeText(o)
                    });
                    break;
                case "Expires":
                    n.expires = parseInt(U.parseNodeText(o), 10);
                    break;
                case "ViewableImpression":
                    n.viewableImpression.push(K(o));
                    break;
                case "Description":
                    n.description = U.parseNodeText(o);
                    break;
                case "Advertiser":
                    n.advertiser = {
                        id: o.getAttribute("id") || null,
                        value: U.parseNodeText(o)
                    };
                    break;
                case "Pricing":
                    n.pricing = {
                        value: U.parseNodeText(o),
                        model: o.getAttribute("model") || null,
                        currency: o.getAttribute("currency") || null
                    };
                    break;
                case "Survey":
                    n.survey = U.parseNodeText(o);
                    break;
                case "BlockedAdCategories":
                    n.blockedAdCategories.push({
                        authority: o.getAttribute("authority") || null,
                        value: U.parseNodeText(o)
                    });
            }
        }
        return r.length && (n.adVerifications = n.adVerifications.concat(r)), n;
    }
    function z(e, t) {
        var r = G(e, t), i = e.getAttribute("followAdditionalWrappers"), n = e.getAttribute("allowMultipleAds"), a = e.getAttribute("fallbackOnNoAd");
        r.followAdditionalWrappers = !i || U.parseBoolean(i), r.allowMultipleAds = !!n && U.parseBoolean(n), r.fallbackOnNoAd = a ? U.parseBoolean(a) : null;
        var o = U.childByName(e, "VASTAdTagURI");
        if (o ? r.nextWrapperURL = U.parseNodeText(o) : (o = U.childByName(e, "VASTAdTagURL")) && (r.nextWrapperURL = U.parseNodeText(U.childByName(o, "URL"))), r.creatives.forEach(function(e) {
            if (-1 !== [
                "linear",
                "nonlinear"
            ].indexOf(e.type)) {
                if (e.trackingEvents) {
                    r.trackingEvents || (r.trackingEvents = {}), r.trackingEvents[e.type] || (r.trackingEvents[e.type] = {});
                    var t = function(t) {
                        var i = e.trackingEvents[t];
                        Array.isArray(r.trackingEvents[e.type][t]) || (r.trackingEvents[e.type][t] = []), i.forEach(function(i) {
                            r.trackingEvents[e.type][t].push(i);
                        });
                    };
                    for(var i in e.trackingEvents)t(i);
                }
                e.videoClickTrackingURLTemplates && (Array.isArray(r.videoClickTrackingURLTemplates) || (r.videoClickTrackingURLTemplates = []), e.videoClickTrackingURLTemplates.forEach(function(e) {
                    r.videoClickTrackingURLTemplates.push(e);
                })), e.videoClickThroughURLTemplate && (r.videoClickThroughURLTemplate = e.videoClickThroughURLTemplate), e.videoCustomClickURLTemplates && (Array.isArray(r.videoCustomClickURLTemplates) || (r.videoCustomClickURLTemplates = []), e.videoCustomClickURLTemplates.forEach(function(e) {
                    r.videoCustomClickURLTemplates.push(e);
                }));
            }
        }), r.nextWrapperURL) return r;
    }
    function Y(e) {
        var t = [];
        return e.forEach(function(e) {
            var r = {
                resource: null,
                vendor: null,
                browserOptional: !1,
                apiFramework: null,
                type: null,
                parameters: null,
                trackingEvents: {}
            }, i = e.childNodes;
            for(var n in U.assignAttributes(e.attributes, r), i){
                var a = i[n];
                switch(a.nodeName){
                    case "JavaScriptResource":
                    case "ExecutableResource":
                        r.resource = U.parseNodeText(a), U.assignAttributes(a.attributes, r);
                        break;
                    case "VerificationParameters":
                        r.parameters = U.parseNodeText(a);
                }
            }
            var o = U.childByName(e, "TrackingEvents");
            o && U.childrenByName(o, "Tracking").forEach(function(e) {
                var t = e.getAttribute("event"), i = U.parseNodeText(e);
                t && i && (Array.isArray(r.trackingEvents[t]) || (r.trackingEvents[t] = []), r.trackingEvents[t].push(i));
            }), t.push(r);
        }), t;
    }
    function X(e) {
        var t = null, r = [];
        return e.some(function(e) {
            return t = U.childByName(e, "AdVerifications");
        }), t && (r = Y(U.childrenByName(t, "Verification"))), r;
    }
    function K(e) {
        var t = {};
        t.id = e.getAttribute("id") || null;
        var r = e.childNodes;
        for(var i in r){
            var n = r[i], a = n.nodeName, o = U.parseNodeText(n);
            if (("Viewable" === a || "NotViewable" === a || "ViewUndetermined" === a) && o) {
                var s = a.toLowerCase();
                Array.isArray(t[s]) || (t[s] = []), t[s].push(o);
            }
        }
        return t;
    }
    var Q = function() {
        function e() {
            n(this, e), this._handlers = [];
        }
        return o(e, [
            {
                key: "on",
                value: function(e, t) {
                    if ("function" != typeof t) throw new TypeError("The handler argument must be of type Function. Received type ".concat(i(t)));
                    if (!e) throw new TypeError("The event argument must be of type String. Received type ".concat(i(e)));
                    return this._handlers.push({
                        event: e,
                        handler: t
                    }), this;
                }
            },
            {
                key: "once",
                value: function(e, t) {
                    return this.on(e, function(e, t, r) {
                        var i = {
                            fired: !1,
                            wrapFn: void 0
                        };
                        function n() {
                            i.fired || (e.off(t, i.wrapFn), i.fired = !0, r.bind(e).apply(void 0, arguments));
                        }
                        return i.wrapFn = n, n;
                    }(this, e, t));
                }
            },
            {
                key: "off",
                value: function(e, t) {
                    return this._handlers = this._handlers.filter(function(r) {
                        return r.event !== e || r.handler !== t;
                    }), this;
                }
            },
            {
                key: "emit",
                value: function(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)r[i - 1] = arguments[i];
                    var n = !1;
                    return this._handlers.forEach(function(t) {
                        "*" === t.event && (n = !0, t.handler.apply(t, [
                            e
                        ].concat(r))), t.event === e && (n = !0, t.handler.apply(t, r));
                    }), n;
                }
            },
            {
                key: "removeAllListeners",
                value: function(e) {
                    return e ? (this._handlers = this._handlers.filter(function(t) {
                        return t.event !== e;
                    }), this) : (this._handlers = [], this);
                }
            },
            {
                key: "listenerCount",
                value: function(e) {
                    return this._handlers.filter(function(t) {
                        return t.event === e;
                    }).length;
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    return this._handlers.reduce(function(t, r) {
                        return r.event === e && t.push(r.handler), t;
                    }, []);
                }
            },
            {
                key: "eventNames",
                value: function() {
                    return this._handlers.map(function(e) {
                        return e.event;
                    });
                }
            }
        ]), e;
    }();
    var J = {
        get: function(e, t, r) {
            r(new Error("Please bundle the library for node to use the node urlHandler"));
        }
    }, $ = 12e4;
    function Z() {
        try {
            var e = new window.XMLHttpRequest;
            return "withCredentials" in e ? e : null;
        } catch (e) {
            return null;
        }
    }
    function ee(e, t, r) {
        var i = r ? 408 : e.status, n = r ? "XHRURLHandler: Request timed out after ".concat(e.timeout, " ms (").concat(i, ")") : "XHRURLHandler: ".concat(e.statusText, " (").concat(i, ")");
        t(new Error(n), null, {
            statusCode: i
        });
    }
    var te = {
        get: function(e, t, r) {
            if ("https:" === window.location.protocol && 0 === e.indexOf("http://")) return r(new Error("XHRURLHandler: Cannot go from HTTPS to HTTP."));
            try {
                var i = Z();
                i.open("GET", e), i.timeout = t.timeout || $, i.withCredentials = t.withCredentials || !1, i.overrideMimeType && i.overrideMimeType("text/xml"), i.onload = function() {
                    return function(e, t) {
                        200 === e.status ? t(null, e.responseXML, {
                            byteLength: e.response.length,
                            statusCode: e.status
                        }) : ee(e, t, !1);
                    }(i, r);
                }, i.onerror = function() {
                    return ee(i, r, !1);
                }, i.onabort = function() {
                    return ee(i, r, !1);
                }, i.ontimeout = function() {
                    return ee(i, r, !0);
                }, i.send();
            } catch (e) {
                r(new Error("XHRURLHandler: Unexpected error"));
            }
        },
        supported: function() {
            return !!Z();
        }
    };
    var re = {
        get: function(e, t, r) {
            return r || ("function" == typeof t && (r = t), t = {}), "undefined" == typeof window || null === window ? J.get(e, t, r) : te.supported() ? te.get(e, t, r) : r(new Error("Current context is not supported by any of the default URLHandlers. Please provide a custom URLHandler"));
        }
    };
    var ie = 0, ne = 0, ae = function(e, t) {
        !e || !t || e <= 0 || t <= 0 || (ne = (ne * ie + 8 * e / t) / ++ie);
    }, oe = {
        ERRORCODE: 900,
        extensions: []
    }, se = function(e) {
        l(r, e);
        var t = p(r);
        function r() {
            var e;
            return n(this, r), (e = t.call(this)).remainingAds = [], e.parentURLs = [], e.errorURLTemplates = [], e.rootErrorURLTemplates = [], e.maxWrapperDepth = null, e.URLTemplateFilters = [], e.fetchingOptions = {}, e.parsingOptions = {}, e;
        }
        return o(r, [
            {
                key: "addURLTemplateFilter",
                value: function(e) {
                    "function" == typeof e && this.URLTemplateFilters.push(e);
                }
            },
            {
                key: "removeURLTemplateFilter",
                value: function() {
                    this.URLTemplateFilters.pop();
                }
            },
            {
                key: "countURLTemplateFilters",
                value: function() {
                    return this.URLTemplateFilters.length;
                }
            },
            {
                key: "clearURLTemplateFilters",
                value: function() {
                    this.URLTemplateFilters = [];
                }
            },
            {
                key: "trackVastError",
                value: function(e, t) {
                    for(var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)i[n - 2] = arguments[n];
                    this.emit("VAST-error", Object.assign.apply(Object, [
                        {},
                        oe,
                        t
                    ].concat(i))), L.track(e, t);
                }
            },
            {
                key: "getErrorURLTemplates",
                value: function() {
                    return this.rootErrorURLTemplates.concat(this.errorURLTemplates);
                }
            },
            {
                key: "getEstimatedBitrate",
                value: function() {
                    return ne;
                }
            },
            {
                key: "fetchVAST",
                value: function(e) {
                    var t = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                    return new Promise(function(a, o) {
                        t.URLTemplateFilters.forEach(function(t) {
                            e = t(e);
                        }), t.parentURLs.push(e);
                        var s = Date.now();
                        t.emit("VAST-resolving", {
                            url: e,
                            previousUrl: i,
                            wrapperDepth: r,
                            maxWrapperDepth: t.maxWrapperDepth,
                            timeout: t.fetchingOptions.timeout,
                            wrapperAd: n
                        }), t.urlHandler.get(e, t.fetchingOptions, function(n, l) {
                            var u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, c = Math.round(Date.now() - s), d = Object.assign({
                                url: e,
                                previousUrl: i,
                                wrapperDepth: r,
                                error: n,
                                duration: c
                            }, u);
                            t.emit("VAST-resolved", d), ae(u.byteLength, c), n ? o(n) : a(l);
                        });
                    });
                }
            },
            {
                key: "initParsingStatus",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.errorURLTemplates = [], this.fetchingOptions = {
                        timeout: e.timeout || $,
                        withCredentials: e.withCredentials
                    }, this.maxWrapperDepth = e.wrapperLimit || 10, this.parentURLs = [], this.parsingOptions = {
                        allowMultipleAds: e.allowMultipleAds
                    }, this.remainingAds = [], this.rootErrorURLTemplates = [], this.rootURL = "", this.urlHandler = e.urlHandler || e.urlhandler || re, this.vastVersion = null, ae(e.byteLength, e.requestDuration);
                }
            },
            {
                key: "getRemainingAds",
                value: function(e) {
                    var t = this;
                    if (0 === this.remainingAds.length) return Promise.reject(new Error("No more ads are available for the given VAST"));
                    var r = e ? L.flatten(this.remainingAds) : this.remainingAds.shift();
                    return this.errorURLTemplates = [], this.parentURLs = [], this.resolveAds(r, {
                        wrapperDepth: 0,
                        url: this.rootURL
                    }).then(function(e) {
                        return t.buildVASTResponse(e);
                    });
                }
            },
            {
                key: "getAndParseVAST",
                value: function(e) {
                    var t = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return this.initParsingStatus(r), this.URLTemplateFilters.forEach(function(t) {
                        e = t(e);
                    }), this.rootURL = e, this.fetchVAST(e).then(function(i) {
                        return r.previousUrl = e, r.isRootVAST = !0, r.url = e, t.parse(i, r).then(function(e) {
                            return t.buildVASTResponse(e);
                        });
                    });
                }
            },
            {
                key: "parseVAST",
                value: function(e) {
                    var t = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return this.initParsingStatus(r), r.isRootVAST = !0, this.parse(e, r).then(function(e) {
                        return t.buildVASTResponse(e);
                    });
                }
            },
            {
                key: "buildVASTResponse",
                value: function(e) {
                    var t, r = {
                        ads: (t = {
                            ads: e,
                            errorURLTemplates: this.getErrorURLTemplates(),
                            version: this.vastVersion
                        }).ads || [],
                        errorURLTemplates: t.errorURLTemplates || [],
                        version: t.version || null
                    };
                    return this.completeWrapperResolving(r), r;
                }
            },
            {
                key: "parseVastXml",
                value: function(e, t) {
                    var r = t.isRootVAST, i = void 0 !== r && r, n = t.url, a = void 0 === n ? null : n, o = t.wrapperDepth, s = void 0 === o ? 0 : o, l = t.allowMultipleAds, u = t.followAdditionalWrappers;
                    if (!e || !e.documentElement || "VAST" !== e.documentElement.nodeName) throw this.emit("VAST-ad-parsed", {
                        type: "ERROR",
                        url: a,
                        wrapperDepth: s
                    }), new Error("Invalid VAST XMLDocument");
                    var c = [], d = e.documentElement.childNodes, p = e.documentElement.getAttribute("version");
                    for(var h in i && p && (this.vastVersion = p), d){
                        var v = d[h];
                        if ("Error" === v.nodeName) {
                            var f = U.parseNodeText(v);
                            i ? this.rootErrorURLTemplates.push(f) : this.errorURLTemplates.push(f);
                        } else if ("Ad" === v.nodeName) {
                            if (this.vastVersion && parseFloat(this.vastVersion) < 3) l = !0;
                            else if (!1 === l && c.length > 1) break;
                            var m = H(v, this.emit.bind(this), {
                                allowMultipleAds: l,
                                followAdditionalWrappers: u
                            });
                            m.ad ? (c.push(m.ad), this.emit("VAST-ad-parsed", {
                                type: m.type,
                                url: a,
                                wrapperDepth: s,
                                adIndex: c.length - 1,
                                vastVersion: p
                            })) : this.trackVastError(this.getErrorURLTemplates(), {
                                ERRORCODE: 101
                            });
                        }
                    }
                    return c;
                }
            },
            {
                key: "parse",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.url, i = void 0 === r ? null : r, n = t.resolveAll, a = void 0 === n || n, o = t.wrapperSequence, s = void 0 === o ? null : o, l = t.previousUrl, u = void 0 === l ? null : l, c = t.wrapperDepth, d = void 0 === c ? 0 : c, p = t.isRootVAST, h = void 0 !== p && p, v = t.followAdditionalWrappers, f = t.allowMultipleAds, m = [];
                    this.vastVersion && parseFloat(this.vastVersion) < 3 && h && (f = !0);
                    try {
                        m = this.parseVastXml(e, {
                            isRootVAST: h,
                            url: i,
                            wrapperDepth: d,
                            allowMultipleAds: f,
                            followAdditionalWrappers: v
                        });
                    } catch (e) {
                        return Promise.reject(e);
                    }
                    return 1 === m.length && null != s && (m[0].sequence = s), !1 === a && (this.remainingAds = U.splitVAST(m), m = this.remainingAds.shift()), this.resolveAds(m, {
                        wrapperDepth: d,
                        previousUrl: u,
                        url: i
                    });
                }
            },
            {
                key: "resolveAds",
                value: function() {
                    var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], r = arguments.length > 1 ? arguments[1] : void 0, i = r.wrapperDepth, n = r.previousUrl, a = r.url, o = [];
                    return n = a, t.forEach(function(t) {
                        var r = e.resolveWrappers(t, i, n);
                        o.push(r);
                    }), Promise.all(o).then(function(t) {
                        var r = L.flatten(t);
                        if (!r && e.remainingAds.length > 0) {
                            var o = e.remainingAds.shift();
                            return e.resolveAds(o, {
                                wrapperDepth: i,
                                previousUrl: n,
                                url: a
                            });
                        }
                        return r;
                    });
                }
            },
            {
                key: "resolveWrappers",
                value: function(e, t, r) {
                    var i = this;
                    return new Promise(function(n) {
                        var a;
                        if (t++, !e.nextWrapperURL) return delete e.nextWrapperURL, n(e);
                        if (t >= i.maxWrapperDepth || -1 !== i.parentURLs.indexOf(e.nextWrapperURL)) return e.errorCode = 302, delete e.nextWrapperURL, n(e);
                        e.nextWrapperURL = U.resolveVastAdTagURI(e.nextWrapperURL, r), i.URLTemplateFilters.forEach(function(t) {
                            e.nextWrapperURL = t(e.nextWrapperURL);
                        });
                        var o = null !== (a = i.parsingOptions.allowMultipleAds) && void 0 !== a ? a : e.allowMultipleAds, s = e.sequence;
                        i.fetchVAST(e.nextWrapperURL, t, r, e).then(function(a) {
                            return i.parse(a, {
                                url: e.nextWrapperURL,
                                previousUrl: r,
                                wrapperSequence: s,
                                wrapperDepth: t,
                                followAdditionalWrappers: e.followAdditionalWrappers,
                                allowMultipleAds: o
                            }).then(function(t) {
                                if (delete e.nextWrapperURL, 0 === t.length) return e.creatives = [], n(e);
                                t.forEach(function(t) {
                                    t && U.mergeWrapperAdData(t, e);
                                }), n(t);
                            });
                        }).catch(function(t) {
                            e.errorCode = 301, e.errorMessage = t.message, n(e);
                        });
                    });
                }
            },
            {
                key: "completeWrapperResolving",
                value: function(e) {
                    if (0 === e.ads.length) this.trackVastError(e.errorURLTemplates, {
                        ERRORCODE: 303
                    });
                    else for(var t = e.ads.length - 1; t >= 0; t--){
                        var r = e.ads[t];
                        (r.errorCode || 0 === r.creatives.length) && (this.trackVastError(r.errorURLTemplates.concat(e.errorURLTemplates), {
                            ERRORCODE: r.errorCode || 303
                        }, {
                            ERRORMESSAGE: r.errorMessage || ""
                        }, {
                            extensions: r.extensions
                        }, {
                            system: r.system
                        }), e.ads.splice(t, 1));
                    }
                }
            }
        ]), r;
    }(Q), le = null, ue = {
        data: {},
        length: 0,
        getItem: function(e) {
            return this.data[e];
        },
        setItem: function(e, t) {
            this.data[e] = t, this.length = Object.keys(this.data).length;
        },
        removeItem: function(e) {
            delete this.data[e], this.length = Object.keys(this.data).length;
        },
        clear: function() {
            this.data = {}, this.length = 0;
        }
    }, ce = function() {
        function e() {
            n(this, e), this.storage = this.initStorage();
        }
        return o(e, [
            {
                key: "initStorage",
                value: function() {
                    if (le) return le;
                    try {
                        le = "undefined" != typeof window && null !== window ? window.localStorage || window.sessionStorage : null;
                    } catch (e) {
                        le = null;
                    }
                    return le && !this.isStorageDisabled(le) || (le = ue).clear(), le;
                }
            },
            {
                key: "isStorageDisabled",
                value: function(e) {
                    var t = "__VASTStorage__";
                    try {
                        if (e.setItem(t, t), e.getItem(t) !== t) return e.removeItem(t), !0;
                    } catch (e) {
                        return !0;
                    }
                    return e.removeItem(t), !1;
                }
            },
            {
                key: "getItem",
                value: function(e) {
                    return this.storage.getItem(e);
                }
            },
            {
                key: "setItem",
                value: function(e, t) {
                    return this.storage.setItem(e, t);
                }
            },
            {
                key: "removeItem",
                value: function(e) {
                    return this.storage.removeItem(e);
                }
            },
            {
                key: "clear",
                value: function() {
                    return this.storage.clear();
                }
            }
        ]), e;
    }(), de = function() {
        function e(t, r, i) {
            n(this, e), this.cappingFreeLunch = t || 0, this.cappingMinimumTimeInterval = r || 0, this.defaultOptions = {
                withCredentials: !1,
                timeout: 0
            }, this.vastParser = new se, this.storage = i || new ce, void 0 === this.lastSuccessfulAd && (this.lastSuccessfulAd = 0), void 0 === this.totalCalls && (this.totalCalls = 0), void 0 === this.totalCallsTimeout && (this.totalCallsTimeout = 0);
        }
        return o(e, [
            {
                key: "getParser",
                value: function() {
                    return this.vastParser;
                }
            },
            {
                key: "lastSuccessfulAd",
                get: function() {
                    return this.storage.getItem("vast-client-last-successful-ad");
                },
                set: function(e) {
                    this.storage.setItem("vast-client-last-successful-ad", e);
                }
            },
            {
                key: "totalCalls",
                get: function() {
                    return this.storage.getItem("vast-client-total-calls");
                },
                set: function(e) {
                    this.storage.setItem("vast-client-total-calls", e);
                }
            },
            {
                key: "totalCallsTimeout",
                get: function() {
                    return this.storage.getItem("vast-client-total-calls-timeout");
                },
                set: function(e) {
                    this.storage.setItem("vast-client-total-calls-timeout", e);
                }
            },
            {
                key: "hasRemainingAds",
                value: function() {
                    return this.vastParser.remainingAds.length > 0;
                }
            },
            {
                key: "getNextAds",
                value: function(e) {
                    return this.vastParser.getRemainingAds(e);
                }
            },
            {
                key: "get",
                value: function(e) {
                    var t = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = Date.now();
                    return (r = Object.assign({}, this.defaultOptions, r)).hasOwnProperty("resolveAll") || (r.resolveAll = !1), this.totalCallsTimeout < i ? (this.totalCalls = 1, this.totalCallsTimeout = i + 36e5) : this.totalCalls++, new Promise(function(n, a) {
                        if (t.cappingFreeLunch >= t.totalCalls) return a(new Error("VAST call canceled – FreeLunch capping not reached yet ".concat(t.totalCalls, "/").concat(t.cappingFreeLunch)));
                        var o = i - t.lastSuccessfulAd;
                        if (o < 0) t.lastSuccessfulAd = 0;
                        else if (o < t.cappingMinimumTimeInterval) return a(new Error("VAST call canceled – (".concat(t.cappingMinimumTimeInterval, ")ms minimum interval reached")));
                        t.vastParser.getAndParseVAST(e, r).then(function(e) {
                            return n(e);
                        }).catch(function(e) {
                            return a(e);
                        });
                    });
                }
            }
        ]), e;
    }(), pe = function(e) {
        l(i, e);
        var t = p(i);
        function i(e, r, a) {
            var o, s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
            for(var l in n(this, i), (o = t.call(this)).ad = r, o.creative = a, o.variation = s, o.muted = !1, o.impressed = !1, o.skippable = !1, o.trackingEvents = {}, o.lastPercentage = 0, o._alreadyTriggeredQuartiles = {}, o.emitAlwaysEvents = [
                "creativeView",
                "start",
                "firstQuartile",
                "midpoint",
                "thirdQuartile",
                "complete",
                "resume",
                "pause",
                "rewind",
                "skip",
                "closeLinear",
                "close"
            ], o.creative.trackingEvents){
                var u = o.creative.trackingEvents[l];
                o.trackingEvents[l] = u.slice(0);
            }
            return I(o.creative) ? o._initLinearTracking() : o._initVariationTracking(), e && o.on("start", function() {
                e.lastSuccessfulAd = Date.now();
            }), o;
        }
        return o(i, [
            {
                key: "_initLinearTracking",
                value: function() {
                    this.linear = !0, this.skipDelay = this.creative.skipDelay, this.setDuration(this.creative.duration), this.clickThroughURLTemplate = this.creative.videoClickThroughURLTemplate, this.clickTrackingURLTemplates = this.creative.videoClickTrackingURLTemplates;
                }
            },
            {
                key: "_initVariationTracking",
                value: function() {
                    if (this.linear = !1, this.skipDelay = -1, this.variation) {
                        for(var e in this.variation.trackingEvents){
                            var t = this.variation.trackingEvents[e];
                            this.trackingEvents[e] ? this.trackingEvents[e] = this.trackingEvents[e].concat(t.slice(0)) : this.trackingEvents[e] = t.slice(0);
                        }
                        "nonLinearAd" === this.variation.adType ? (this.clickThroughURLTemplate = this.variation.nonlinearClickThroughURLTemplate, this.clickTrackingURLTemplates = this.variation.nonlinearClickTrackingURLTemplates, this.setDuration(this.variation.minSuggestedDuration)) : function(e) {
                            return "companionAd" === e.adType;
                        }(this.variation) && (this.clickThroughURLTemplate = this.variation.companionClickThroughURLTemplate, this.clickTrackingURLTemplates = this.variation.companionClickTrackingURLTemplates);
                    }
                }
            },
            {
                key: "setDuration",
                value: function(e) {
                    this.assetDuration = e, this.quartiles = {
                        firstQuartile: Math.round(25 * this.assetDuration) / 100,
                        midpoint: Math.round(50 * this.assetDuration) / 100,
                        thirdQuartile: Math.round(75 * this.assetDuration) / 100
                    };
                }
            },
            {
                key: "setProgress",
                value: function(e) {
                    var t = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = this.skipDelay || -1;
                    if (-1 === i || this.skippable || (i > e ? this.emit("skip-countdown", i - e) : (this.skippable = !0, this.emit("skip-countdown", 0))), this.assetDuration > 0) {
                        var n = Math.round(e / this.assetDuration * 100), a = [];
                        if (e > 0) {
                            a.push("start");
                            for(var o = this.lastPercentage; o < n; o++)a.push("progress-".concat(o + 1, "%"));
                            for(var s in a.push("progress-".concat(Math.round(e))), this.quartiles)this.isQuartileReached(s, this.quartiles[s], e) && (a.push(s), this._alreadyTriggeredQuartiles[s] = !0);
                            this.lastPercentage = n;
                        }
                        a.forEach(function(e) {
                            t.track(e, {
                                macros: r,
                                once: !0
                            });
                        }), e < this.progress && this.track("rewind", {
                            macros: r
                        });
                    }
                    this.progress = e;
                }
            },
            {
                key: "isQuartileReached",
                value: function(e, t, r) {
                    var i = !1;
                    return t <= r && !this._alreadyTriggeredQuartiles[e] && (i = !0), i;
                }
            },
            {
                key: "setMuted",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    this.muted !== e && this.track(e ? "mute" : "unmute", {
                        macros: t
                    }), this.muted = e;
                }
            },
            {
                key: "setPaused",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    this.paused !== e && this.track(e ? "pause" : "resume", {
                        macros: t
                    }), this.paused = e;
                }
            },
            {
                key: "setFullscreen",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    this.fullscreen !== e && this.track(e ? "fullscreen" : "exitFullscreen", {
                        macros: t
                    }), this.fullscreen = e;
                }
            },
            {
                key: "setExpand",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    this.expanded !== e && (this.track(e ? "expand" : "collapse", {
                        macros: t
                    }), this.track(e ? "playerExpand" : "playerCollapse", {
                        macros: t
                    })), this.expanded = e;
                }
            },
            {
                key: "setSkipDelay",
                value: function(e) {
                    "number" == typeof e && (this.skipDelay = e);
                }
            },
            {
                key: "trackImpression",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.impressed || (this.impressed = !0, this.trackURLs(this.ad.impressionURLTemplates, e), this.track("creativeView", {
                        macros: e
                    }));
                }
            },
            {
                key: "error",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    this.trackURLs(this.ad.errorURLTemplates, e, {
                        isCustomCode: t
                    });
                }
            },
            {
                key: "errorWithCode",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    this.error({
                        ERRORCODE: e
                    }, t), console.log("The method errorWithCode is deprecated, please use vast tracker error method instead");
                }
            },
            {
                key: "complete",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("complete", {
                        macros: e
                    });
                }
            },
            {
                key: "notUsed",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("notUsed", {
                        macros: e
                    }), this.trackingEvents = [];
                }
            },
            {
                key: "otherAdInteraction",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("otherAdInteraction", {
                        macros: e
                    });
                }
            },
            {
                key: "acceptInvitation",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("acceptInvitation", {
                        macros: e
                    });
                }
            },
            {
                key: "adExpand",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("adExpand", {
                        macros: e
                    });
                }
            },
            {
                key: "adCollapse",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("adCollapse", {
                        macros: e
                    });
                }
            },
            {
                key: "minimize",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("minimize", {
                        macros: e
                    });
                }
            },
            {
                key: "verificationNotExecuted",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!this.ad || !this.ad.adVerifications || !this.ad.adVerifications.length) throw new Error("No adVerifications provided");
                    if (!e) throw new Error("No vendor provided, unable to find associated verificationNotExecuted");
                    var r = this.ad.adVerifications.find(function(t) {
                        return t.vendor === e;
                    });
                    if (!r) throw new Error("No associated verification element found for vendor: ".concat(e));
                    var i = r.trackingEvents;
                    if (i && i.verificationNotExecuted) {
                        var n = i.verificationNotExecuted;
                        this.trackURLs(n, t), this.emit("verificationNotExecuted", {
                            trackingURLTemplates: n
                        });
                    }
                }
            },
            {
                key: "overlayViewDuration",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    t.ADPLAYHEAD = e, this.track("overlayViewDuration", {
                        macros: t
                    });
                }
            },
            {
                key: "close",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track(this.linear ? "closeLinear" : "close", {
                        macros: e
                    });
                }
            },
            {
                key: "skip",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("skip", {
                        macros: e
                    });
                }
            },
            {
                key: "load",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    this.track("loaded", {
                        macros: e
                    });
                }
            },
            {
                key: "click",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    this.clickTrackingURLTemplates && this.clickTrackingURLTemplates.length && this.trackURLs(this.clickTrackingURLTemplates, t);
                    var i = this.clickThroughURLTemplate || e, n = r({}, t);
                    if (i) {
                        this.progress && (n.ADPLAYHEAD = this.progressFormatted());
                        var a = L.resolveURLTemplates([
                            i
                        ], n)[0];
                        this.emit("clickthrough", a);
                    }
                }
            },
            {
                key: "track",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.macros, i = void 0 === r ? {} : r, n = t.once, a = void 0 !== n && n;
                    "closeLinear" === e && !this.trackingEvents[e] && this.trackingEvents.close && (e = "close");
                    var o = this.trackingEvents[e], s = this.emitAlwaysEvents.indexOf(e) > -1;
                    o ? (this.emit(e, {
                        trackingURLTemplates: o
                    }), this.trackURLs(o, i)) : s && this.emit(e, null), a && (delete this.trackingEvents[e], s && this.emitAlwaysEvents.splice(this.emitAlwaysEvents.indexOf(e), 1));
                }
            },
            {
                key: "trackURLs",
                value: function(e) {
                    var t, i, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = r({}, n);
                    this.linear && (this.creative && this.creative.mediaFiles && this.creative.mediaFiles[0] && this.creative.mediaFiles[0].fileURL && (o.ASSETURI = this.creative.mediaFiles[0].fileURL), this.progress && (o.ADPLAYHEAD = this.progressFormatted())), null !== (t = this.creative) && void 0 !== t && null !== (i = t.universalAdIds) && void 0 !== i && i.length && (o.UNIVERSALADID = this.creative.universalAdIds.map(function(e) {
                        return e.idRegistry.concat(" ", e.value);
                    }).join(",")), this.ad && (this.ad.sequence && (o.PODSEQUENCE = this.ad.sequence), this.ad.adType && (o.ADTYPE = this.ad.adType), this.ad.adServingId && (o.ADSERVINGID = this.ad.adServingId), this.ad.categories && this.ad.categories.length && (o.ADCATEGORIES = this.ad.categories.map(function(e) {
                        return e.value;
                    }).join(",")), this.ad.blockedAdCategories && this.ad.blockedAdCategories.length && (o.BLOCKEDADCATEGORIES = this.ad.blockedAdCategories)), L.track(e, o, a);
                }
            },
            {
                key: "convertToTimecode",
                value: function(e) {
                    var t = 1e3 * e, r = Math.floor(t / 36e5), i = Math.floor(t / 6e4 % 60), n = Math.floor(t / 1e3 % 60), a = Math.floor(t % 1e3);
                    return "".concat(L.leftpad(r, 2), ":").concat(L.leftpad(i, 2), ":").concat(L.leftpad(n, 2), ".").concat(L.leftpad(a, 3));
                }
            },
            {
                key: "progressFormatted",
                value: function() {
                    return this.convertToTimecode(this.progress);
                }
            }
        ]), i;
    }(Q);
    e.VASTClient = de, e.VASTParser = se, e.VASTTracker = pe, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});


var $6458bf7afce356f3$exports = {};

$parcel$defineInteropFlag($6458bf7afce356f3$exports);

$parcel$export($6458bf7afce356f3$exports, "default", () => $6458bf7afce356f3$export$2e2bcd8739ae039);
class $391bc9aac665ac13$var$VMAPAdSource {
    constructor(xml){
        this.id = xml.getAttribute("id");
        this.allowMultipleAds = xml.getAttribute("allowMultipleAds");
        this.followRedirects = xml.getAttribute("followRedirects");
        this.vastAdData = null;
        this.adTagURI = null;
        this.customData = null;
        for(const nodeKey in xml.childNodes){
            const node = xml.childNodes[nodeKey];
            switch(node.localName){
                case "AdTagURI":
                    this.adTagURI = {
                        templateType: node.getAttribute("templateType"),
                        uri: (node.textContent || node.text || "").trim()
                    };
                    break;
                case "VASTAdData":
                    this.vastAdData = node.firstChild;
                    // Some browsers treats empty white-spaces or new lines as text nodes.
                    // Ensure we get the first element node
                    while(this.vastAdData && this.vastAdData.nodeType !== 1)this.vastAdData = this.vastAdData.nextSibling;
                    break;
                case "CustomAdData":
                    this.customData = node;
                    break;
            }
        }
    }
}
var $391bc9aac665ac13$export$2e2bcd8739ae039 = $391bc9aac665ac13$var$VMAPAdSource;


/**
 * Returns all the elements of the given node which nodeName match the given name.
 * @param  {Node} node - The node to use to find the matches.
 * @param  {String} name - The name to look for.
 * @return {Array<ChildNode>}
 */ function $242ffd312fae576a$export$3e670bfce58ef6b1(node, name) {
    const children = [];
    for(const childKey in node.childNodes){
        const child = node.childNodes[childKey];
        if (child.nodeName === name || name === `vmap:${child.nodeName}` || child.nodeName === `vmap:${name}`) children.push(child);
    }
    return children;
}
/**
 * Parses a node value giving priority to CDATA as a JSON over text, if CDATA is not a valid JSON it is converted to text
 * @param  {Node} node - The node to parse the value from.
 * @return {String|Object}
 */ function $242ffd312fae576a$export$f1076c2aad719c23(node) {
    if (!node || !node.childNodes) return {};
    const childNodes = node.childNodes;
    // Trying to find and parse CDATA as JSON
    const cdatas = [];
    for(const childKey in childNodes){
        const childNode = childNodes[childKey];
        if (childNode.nodeName === "#cdata-section") cdatas.push(childNode);
    }
    if (cdatas && cdatas.length > 0) try {
        return JSON.parse(cdatas[0].data);
    } catch (e) {}
    // Didn't find any CDATA or failed to parse it as JSON
    let nodeText = "";
    for(const childKey in childNodes){
        const childNode = childNodes[childKey];
        switch(childNode.nodeName){
            case "#text":
                nodeText += childNode.textContent.trim();
                break;
            case "#cdata-section":
                nodeText += childNode.data;
                break;
        }
    }
    return nodeText;
}
/**
 * Parses an XML node recursively.
 * @param  {Node} node - The node to parse.
 * @return {Object}
 */ function $242ffd312fae576a$export$3958e879bc3a3e19(node) {
    const parsedNode = {
        attributes: {},
        children: {},
        value: {}
    };
    parsedNode.value = $242ffd312fae576a$export$f1076c2aad719c23(node);
    const attributes = node.attributes;
    if (attributes) for(const attrKey in attributes){
        const nodeAttr = attributes[attrKey];
        if (nodeAttr.nodeName && nodeAttr.nodeValue !== undefined && nodeAttr.nodeValue !== null) parsedNode.attributes[nodeAttr.nodeName] = nodeAttr.nodeValue;
    }
    const childNodes = node.childNodes;
    if (childNodes) for(const childKey in childNodes){
        const childNode = childNodes[childKey];
        if (childNode.nodeName && childNode.nodeName.substring(0, 1) !== "#") parsedNode.children[childNode.nodeName] = $242ffd312fae576a$export$3958e879bc3a3e19(childNode);
    }
    return parsedNode;
}


class $0850e31c6f441c2f$var$VMAPAdBreak {
    constructor(xml){
        this.timeOffset = xml.getAttribute("timeOffset");
        this.breakType = xml.getAttribute("breakType");
        this.breakId = xml.getAttribute("breakId");
        this.repeatAfter = xml.getAttribute("repeatAfter");
        this.adSource = null;
        this.trackingEvents = [];
        this.extensions = [];
        for(const nodeKey in xml.childNodes){
            const node = xml.childNodes[nodeKey];
            switch(node.localName){
                case "AdSource":
                    this.adSource = new (0, $391bc9aac665ac13$export$2e2bcd8739ae039)(node);
                    break;
                case "TrackingEvents":
                    for(const subnodeKey in node.childNodes){
                        const subnode = node.childNodes[subnodeKey];
                        if (subnode.localName === "Tracking") this.trackingEvents.push({
                            event: subnode.getAttribute("event"),
                            uri: (subnode.textContent || subnode.text || "").trim()
                        });
                    }
                    break;
                case "Extensions":
                    this.extensions = (0, $242ffd312fae576a$export$3e670bfce58ef6b1)(node, "Extension").map((extension)=>(0, $242ffd312fae576a$export$3958e879bc3a3e19)(extension));
                    break;
            }
        }
    }
    track(event, errorCode) {
        for(const trackerKey in this.trackingEvents){
            const tracker = this.trackingEvents[trackerKey];
            if (tracker.event === event) {
                let { uri: uri } = tracker;
                if (tracker.event === "error") uri = uri.replace("[ERRORCODE]", errorCode);
                this.tracker(uri);
            }
        }
    }
    // Easy to overwrite tracker client for unit testing
    tracker(uri) {
        if (typeof window !== "undefined" && window !== null) {
            const i = new Image();
            i.src = uri;
        }
    }
}
var $0850e31c6f441c2f$export$2e2bcd8739ae039 = $0850e31c6f441c2f$var$VMAPAdBreak;



class $286976e4b39893d1$var$VMAP {
    constructor(xml){
        if (!xml || !xml.documentElement || xml.documentElement.localName !== "VMAP") throw new Error("Not a VMAP document");
        this.version = xml.documentElement.getAttribute("version");
        this.adBreaks = [];
        this.extensions = [];
        for(const nodeKey in xml.documentElement.childNodes){
            const node = xml.documentElement.childNodes[nodeKey];
            switch(node.localName){
                case "AdBreak":
                    this.adBreaks.push(new (0, $0850e31c6f441c2f$export$2e2bcd8739ae039)(node));
                    break;
                case "Extensions":
                    this.extensions = (0, $242ffd312fae576a$export$3e670bfce58ef6b1)(node, "Extension").map((extension)=>(0, $242ffd312fae576a$export$3958e879bc3a3e19)(extension));
                    break;
            }
        }
    }
}
var $286976e4b39893d1$export$2e2bcd8739ae039 = $286976e4b39893d1$var$VMAP;


var $6458bf7afce356f3$export$2e2bcd8739ae039 = (0, $286976e4b39893d1$export$2e2bcd8739ae039);


var $d3991ab488021f88$exports = {};

$parcel$defineInteropFlag($d3991ab488021f88$exports);

$parcel$export($d3991ab488021f88$exports, "default", () => $d3991ab488021f88$export$2e2bcd8739ae039);
function $d3991ab488021f88$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}


function $8e77a7afa455b288$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $8e77a7afa455b288$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $8e77a7afa455b288$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$8e77a7afa455b288$var$$parcel$export($8e77a7afa455b288$exports, "AdBreakTrackingEvent", ()=>$8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9);
$8e77a7afa455b288$var$$parcel$export($8e77a7afa455b288$exports, "AdTrackingEvent", ()=>$8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d);
var $8e77a7afa455b288$var$$020ad56d15653aeb$exports = {};
$8e77a7afa455b288$var$$parcel$export($8e77a7afa455b288$var$$020ad56d15653aeb$exports, "CSAIManager", ()=>$8e77a7afa455b288$var$$020ad56d15653aeb$export$b74fc88014c397b3, (v)=>$8e77a7afa455b288$var$$020ad56d15653aeb$export$b74fc88014c397b3 = v);
var $8e77a7afa455b288$var$$82676b94e7d3e1ec$exports = {};
$8e77a7afa455b288$var$$parcel$export($8e77a7afa455b288$var$$82676b94e7d3e1ec$exports, "AdServerService", ()=>$8e77a7afa455b288$var$$82676b94e7d3e1ec$export$3352be5704672342, (v)=>$8e77a7afa455b288$var$$82676b94e7d3e1ec$export$3352be5704672342 = v);
var $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d;
(function($6a91d1a6b96ec270$export$af003d03c08e493d) {
    $6a91d1a6b96ec270$export$af003d03c08e493d["START"] = "start";
    $6a91d1a6b96ec270$export$af003d03c08e493d["IMPRESSION"] = "impression";
    $6a91d1a6b96ec270$export$af003d03c08e493d["EXPAND"] = "expand";
    $6a91d1a6b96ec270$export$af003d03c08e493d["MUTE"] = "mute";
    $6a91d1a6b96ec270$export$af003d03c08e493d["UNMUTE"] = "unmute";
    $6a91d1a6b96ec270$export$af003d03c08e493d["PAUSE"] = "pause";
    $6a91d1a6b96ec270$export$af003d03c08e493d["RESUME"] = "resume";
    $6a91d1a6b96ec270$export$af003d03c08e493d["REWIND"] = "rewind";
    $6a91d1a6b96ec270$export$af003d03c08e493d["CLOSE"] = "close";
    $6a91d1a6b96ec270$export$af003d03c08e493d["COMPLETE"] = "complete";
    $6a91d1a6b96ec270$export$af003d03c08e493d["FIRST_QUARTILE"] = "firstQuartile";
    $6a91d1a6b96ec270$export$af003d03c08e493d["MIDPOINT"] = "midpoint";
    $6a91d1a6b96ec270$export$af003d03c08e493d["THIRD_QUARTILE"] = "thirdQuartile";
    $6a91d1a6b96ec270$export$af003d03c08e493d["CLICK_THROUGH"] = "clickThrough";
    $6a91d1a6b96ec270$export$af003d03c08e493d["ERROR"] = "error";
})($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d || ($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d = {}));
var $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9;
(function($6a91d1a6b96ec270$export$8ee40f6ae4909ee9) {
    $6a91d1a6b96ec270$export$8ee40f6ae4909ee9["BREAK_START"] = "breakStart";
    $6a91d1a6b96ec270$export$8ee40f6ae4909ee9["BREAK_END"] = "breakEnd";
})($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9 || ($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9 = {}));
var $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$f9cba49277c3a748;
(function($6a91d1a6b96ec270$export$f9cba49277c3a748) {
    $6a91d1a6b96ec270$export$f9cba49277c3a748["ClientSide"] = "csai";
    $6a91d1a6b96ec270$export$f9cba49277c3a748["ServerSide"] = "ssai";
})($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$f9cba49277c3a748 || ($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$f9cba49277c3a748 = {}));
var $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$21ab339cd8e953dc;
(function($6a91d1a6b96ec270$export$21ab339cd8e953dc) {
    $6a91d1a6b96ec270$export$21ab339cd8e953dc["Preroll"] = "preroll";
    $6a91d1a6b96ec270$export$21ab339cd8e953dc["Midroll"] = "midroll";
    $6a91d1a6b96ec270$export$21ab339cd8e953dc["Postroll"] = "postroll";
})($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$21ab339cd8e953dc || ($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$21ab339cd8e953dc = {}));
var $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$3d6415b1a42429de;
(function($6a91d1a6b96ec270$export$3d6415b1a42429de) {
    $6a91d1a6b96ec270$export$3d6415b1a42429de["NORMAL"] = "NORMAL";
    $6a91d1a6b96ec270$export$3d6415b1a42429de["SPONSOR"] = "BUMPER";
    $6a91d1a6b96ec270$export$3d6415b1a42429de["VIGNETTE"] = "VIGNETTE";
    $6a91d1a6b96ec270$export$3d6415b1a42429de["TRAILER"] = "TRAILER";
})($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$3d6415b1a42429de || ($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$3d6415b1a42429de = {}));
var $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$66a223aa8aa4adc3 = {
    id: "unknown_advert",
    title: "",
    creative: {
        id: "unknown_creative",
        type: "?",
        mediafiles: [],
        trackingEvents: {}
    }
};
function $8e77a7afa455b288$var$$c2c23ffc2593fda7$export$7d60f72cc3d90ae5(dateString) {
    var p = dateString.split(":"), s = 0, m = 1;
    while(p.length > 0){
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
}
function $8e77a7afa455b288$var$$c2c23ffc2593fda7$export$ff9d762dbf7e2cc6(contentVideoElement) {
    var adVideoElement = document.createElement("video");
    adVideoElement.style.position = "absolute";
    adVideoElement.style.top = "0";
    adVideoElement.style.left = "0";
    adVideoElement.style.width = "100%";
    adVideoElement.style.height = "100%";
    adVideoElement.style.backgroundColor = "black";
    adVideoElement.style.display = "none";
    if (contentVideoElement) {
        adVideoElement.playsInline = contentVideoElement.playsInline;
        adVideoElement.muted = contentVideoElement.muted;
        adVideoElement.volume = contentVideoElement.volume;
    }
    return adVideoElement;
}
var $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__assign = function() {
    $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__assign.apply(this, arguments);
};
var $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__generator = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__spreadArray = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8e77a7afa455b288$var$$82676b94e7d3e1ec$export$3352be5704672342 = /** @class */ function() {
    function $82676b94e7d3e1ec$export$3352be5704672342(debug) {
        if (debug === void 0) debug = false;
        this.debug = false;
        this.estimatedBandwidth = 500;
        this.debug = !!debug;
        this.vastParser = new $b92673c9958612fb$exports.VASTParser();
    }
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.getVMAP = function(url) {
        return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var vmapObject, adBreaks;
            return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.debug) console.debug("[CSAIManager] getVMAP", url);
                        return [
                            4 /*yield*/ ,
                            this.fetchAdsVMAP(url)
                        ];
                    case 1:
                        vmapObject = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.resolveAds(vmapObject)
                        ];
                    case 2:
                        adBreaks = _a.sent();
                        if (this.debug) console.debug("[CSAIManager] resolved VMAP to ad breaks", adBreaks);
                        return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.getVASTs = function(vastItems) {
        return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var adBreaks, _i, vastItems_1, vastItem, vastAdBreak, adBreakAds;
            return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.debug) console.debug("[CSAIManager] getVASTs", vastItems);
                        adBreaks = [];
                        _i = 0, vastItems_1 = vastItems;
                        _a.label = 1;
                    case 1:
                        if (!(_i < vastItems_1.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        vastItem = vastItems_1[_i];
                        return [
                            4 /*yield*/ ,
                            this.vastParser.getAndParseVAST(vastItem.vastUrl)
                        ];
                    case 2:
                        vastAdBreak = _a.sent();
                        if (!vastAdBreak) return [
                            2 /*return*/ 
                        ];
                        adBreakAds = vastAdBreak.ads;
                        adBreaks.push(this.mapAdBreakObject({
                            timeOffset: vastItem.timeOffset.toString()
                        }, adBreakAds));
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        if (this.debug) console.debug("[CSAIManager] resolved VAST to ad break", adBreaks);
                        return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.getVast = function(vastUrl) {
        return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var vastAdBreak, adBreakAds, adbreak;
            return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.debug) console.debug("[CSAIManager] get vast", vastUrl);
                        return [
                            4 /*yield*/ ,
                            this.vastParser.getAndParseVAST(vastUrl)
                        ];
                    case 1:
                        vastAdBreak = _a.sent();
                        if (!vastAdBreak) return [
                            2 /*return*/ 
                        ];
                        adBreakAds = vastAdBreak.ads;
                        adbreak = this.mapAdBreakObject({
                            timeOffset: "100"
                        }, adBreakAds);
                        if (this.debug) console.debug("[CSAIManager] resolved vast to ad break", adbreak);
                        return [
                            2 /*return*/ ,
                            adbreak
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.fetchAdsVMAP = function(u) {
        return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var response, xml, xmlParser, xmlDoc, vmapObject;
            return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch(u)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        xml = _a.sent();
                        xmlParser = new DOMParser();
                        xmlDoc = xmlParser.parseFromString(xml, "text/xml");
                        vmapObject = new ($8e77a7afa455b288$var$$parcel$interopDefault($6458bf7afce356f3$exports))(xmlDoc);
                        return [
                            2 /*return*/ ,
                            vmapObject
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.resolveAds = function(vmapObject) {
        var _a;
        return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__awaiter(this, void 0, Promise, function() {
            var adBreaks, _i, _b, adBreak, adsInBreak, adBreakAds, options;
            return $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        adBreaks = [];
                        _i = 0, _b = vmapObject.adBreaks;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _b.length)) return [
                            3 /*break*/ ,
                            5
                        ];
                        adBreak = _b[_i];
                        if (adBreak.breakType !== "linear") return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                        adsInBreak = (_a = adBreak.adSource) === null || _a === void 0 ? void 0 : _a.vastAdData;
                        adBreakAds = [];
                        if (!adsInBreak) return [
                            3 /*break*/ ,
                            3
                        ];
                        options = {
                            isRootVAST: true,
                            timeout: 10000,
                            withCredentials: true,
                            wrapperLimit: 10,
                            followAdditionalWrappers: true
                        };
                        this.vastParser.initParsingStatus(options);
                        return [
                            4 /*yield*/ ,
                            this.vastParser.parseVAST({
                                documentElement: adsInBreak
                            }, options)
                        ];
                    case 2:
                        adBreakAds = _c.sent().ads;
                        this.estimatedBandwidth = this.vastParser.getEstimatedBitrate();
                        _c.label = 3;
                    case 3:
                        adBreaks.push(this.mapAdBreakObject(adBreak, adBreakAds));
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            adBreaks
                        ];
                }
            });
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapAdBreakObject = function(adBreak, ads) {
        var _this = this;
        var _a, _b, _c, _d;
        var adBreakObject = {
            insertionType: $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$f9cba49277c3a748.ClientSide,
            breakType: adBreak.timeOffset === "start" || adBreak.timeOffset === "0" ? $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$21ab339cd8e953dc.Preroll : $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$21ab339cd8e953dc.Midroll,
            timeOffset: adBreak.timeOffset === "start" || adBreak.timeOffset === "0" ? 0 : $8e77a7afa455b288$var$$c2c23ffc2593fda7$export$7d60f72cc3d90ae5(adBreak.timeOffset),
            ads: ads === null || ads === void 0 ? void 0 : ads.map(function(ad) {
                return _this.mapAdsObject(ad);
            }).filter(function(ad) {
                return ad !== null;
            }),
            trackingEvents: {
                breakStart: ((_b = (_a = adBreak.trackingEvents) === null || _a === void 0 ? void 0 : _a.filter(function(abte) {
                    return abte.event === $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_START;
                })) === null || _b === void 0 ? void 0 : _b.map(function(abte) {
                    return abte.uri;
                })) || [],
                breakEnd: ((_d = (_c = adBreak.trackingEvents) === null || _c === void 0 ? void 0 : _c.filter(function(abte) {
                    return abte.event === $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_END;
                })) === null || _d === void 0 ? void 0 : _d.map(function(abte) {
                    return abte.uri;
                })) || []
            }
        };
        return adBreakObject;
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapAdsObject = function(ad) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var adServerExtension = ad.extensions.find(function(extension) {
            return extension.attributes.type === "AdServer";
        });
        var customAdId = ((_b = (_a = adServerExtension === null || adServerExtension === void 0 ? void 0 : adServerExtension.children.find(function(ext) {
            return ext.name === "AdInfo";
        })) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.customaid) || undefined;
        var variant = ((_d = (_c = adServerExtension === null || adServerExtension === void 0 ? void 0 : adServerExtension.children.find(function(ext) {
            return ext.name === "AdInfo";
        })) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.variant) || $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$3d6415b1a42429de.NORMAL;
        var creative1 = this.findCreative(ad.creatives.map(function(creative) {
            return _this.mapCreativeObject(creative);
        }));
        if (!creative1) return null;
        var adObject = {
            id: ad.id,
            customAdId: customAdId,
            programmatic: customAdId === "PROGRAMMATIC",
            system: (_e = ad.system) === null || _e === void 0 ? void 0 : _e.value,
            sequence: ad.sequence,
            title: ad.title,
            variant: variant,
            creative: creative1,
            errorUrlTemplates: ad.errorURLTemplates,
            impressionUrlTemplates: ad.impressionURLTemplates.map(function(impressionUrlTemplate) {
                return impressionUrlTemplate.url;
            })
        };
        return adObject;
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.findCreative = function(creatives) {
        return creatives.find(function(creative) {
            return creative.type === "linear" && creative.mediafiles.length > 0;
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapCreativeObject = function(creative) {
        var _a;
        var _this = this;
        var creativeObject = {
            id: creative.id,
            adId: creative.adId,
            type: creative.type,
            duration: creative.duration,
            mediafiles: this.filterMediaFiles(creative.mediaFiles.map(function(mediaFile) {
                return _this.mapMediaFileObject(mediaFile);
            })),
            trackingEvents: $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__assign((_a = {}, _a[$8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.CLICK_THROUGH] = $8e77a7afa455b288$var$$82676b94e7d3e1ec$var$__spreadArray([], creative.videoClickTrackingURLTemplates, true), _a), creative.trackingEvents),
            clickThroughUrlTemplate: creative.videoClickThroughURLTemplate
        };
        return creativeObject;
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.filterMediaFiles = function(mediaFiles) {
        var _this = this;
        var playableMediaFiles = mediaFiles.filter(function(mediaFile) {
            return mediaFile.mimeType === "video/mp4";
        });
        var files = playableMediaFiles.filter(function(mediaFile) {
            return mediaFile.mimeType === "video/mp4" && mediaFile.fileUrl.length > 0 && (!mediaFile.bitrate || mediaFile.bitrate < _this.estimatedBandwidth);
        });
        // if no files are found, return the lowest one
        if (files.length === 0) files = playableMediaFiles;
        // otherwise return the filtered list top down
        return files.sort(function(a, b) {
            return a.bitrate && b.bitrate ? a.bitrate - b.bitrate : 0;
        });
    };
    $82676b94e7d3e1ec$export$3352be5704672342.prototype.mapMediaFileObject = function(mediaFile) {
        var mediaFileObject = {
            id: mediaFile.id,
            mimeType: mediaFile.mimeType,
            fileUrl: mediaFile.fileURL,
            bitrate: mediaFile.bitrate,
            height: mediaFile.height,
            width: mediaFile.width
        };
        return mediaFileObject;
    };
    return $82676b94e7d3e1ec$export$3352be5704672342;
}();
var $8e77a7afa455b288$var$$cc312ea0fc7c8651$export$691d3e4b1045a188 = /** @class */ function() {
    function $cc312ea0fc7c8651$export$691d3e4b1045a188() {
        this.emitter = $8e77a7afa455b288$var$$parcel$interopDefault($d3991ab488021f88$exports)();
    }
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.on = function(event, handler) {
        this.emitter.on.apply(this, [
            event,
            handler
        ]);
    };
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.off = function(event, handler) {
        if (this.emitter) this.emitter.off.apply(this, [
            event,
            handler
        ]);
    };
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.clear = function() {
        this.emitter.all.clear();
    };
    $cc312ea0fc7c8651$export$691d3e4b1045a188.prototype.emit = function(event, data) {
        if (this.emitter) this.emitter.emit.apply(this, [
            event,
            data
        ]);
    };
    return $cc312ea0fc7c8651$export$691d3e4b1045a188;
}();
function $8e77a7afa455b288$var$$e68d46ff2e90f1a5$export$d2858fcef9c76970(initOptions) {
    var _a;
    if (!initOptions.container && !initOptions.adVideoElement) {
        console.warn("[CSAIManager] container or adVideoElement is expected, choosing the parent of contentVideoElement as container");
        initOptions.container = initOptions.contentVideoElement.parentElement;
    }
    if (initOptions.container && initOptions.adVideoElement) {
        console.warn("[CSAIManager] either container or adVideoElement is expected, not both, choosing the adVideoElement");
        delete initOptions.container;
    }
    if (!initOptions.isLive && !initOptions.vmapUrl && !initOptions.adBreakVASTList) console.error("[CSAIManager] vmapUrl or adBreakVASTList is required");
    if (initOptions.vmapUrl && initOptions.adBreakVASTList) {
        console.warn("[CSAIManager] either vmapUrl or adBreakVASTList is expected, not both, choosing the adBreakVASTList");
        delete initOptions.vmapUrl;
    }
    if (initOptions.isLive && (initOptions.vmapUrl || ((_a = initOptions.adBreakVASTList) === null || _a === void 0 ? void 0 : _a.length) > 1)) console.warn("[CSAIManager] isLive is true, vmapUrl and adBreakVASTList are not expected, ignoring them");
    return initOptions;
}
var $8e77a7afa455b288$var$$020ad56d15653aeb$var$__extends = function() {
    var extendStatics = function(d1, b1) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d1, b1);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8e77a7afa455b288$var$$020ad56d15653aeb$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e77a7afa455b288$var$$020ad56d15653aeb$var$__generator = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8e77a7afa455b288$var$$020ad56d15653aeb$export$b74fc88014c397b3 = /** @class */ function(_super) {
    $8e77a7afa455b288$var$$020ad56d15653aeb$var$__extends($020ad56d15653aeb$export$b74fc88014c397b3, _super);
    function $020ad56d15653aeb$export$b74fc88014c397b3(initOptions) {
        var _this = _super.call(this) || this;
        _this.debug = false;
        _this.autoManagePlayback = true;
        _this.adBreaks = [];
        _this.adMarkers = [];
        _this.currentAdBreakVideos = [];
        _this.validCurrentTime = 0;
        _this.trackedAdBreaks = {};
        _this.trackedAds = {};
        _this.debug = !!initOptions.debug;
        _this.initOptions = initOptions;
        _this.state = "idle";
        _this.adServerService = new $8e77a7afa455b288$var$$82676b94e7d3e1ec$exports.AdServerService(_this.debug);
        initOptions = $8e77a7afa455b288$var$$e68d46ff2e90f1a5$export$d2858fcef9c76970(initOptions);
        if (_this.autoManagePlayback) initOptions.contentVideoElement.pause();
        _this.contentVideoElement = initOptions.contentVideoElement;
        _this.adVideoElement = _this.setupAdVideoElement(initOptions);
        _this.videoEventFilter = new $ceb203e02a2dd5c7$exports.VideoEventFilter(_this.adVideoElement);
        _this.autoManagePlayback = initOptions.autoManagePlayback ? initOptions.autoManagePlayback : true;
        _this.fetchAds(initOptions);
        return _this;
    }
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.setupAdVideoElement = function(initOptions) {
        if (initOptions.adVideoElement) return initOptions.adVideoElement;
        if (initOptions.container) {
            var adVideoElement = $8e77a7afa455b288$var$$c2c23ffc2593fda7$export$ff9d762dbf7e2cc6(this.contentVideoElement);
            initOptions.container.appendChild(adVideoElement);
            return adVideoElement;
        }
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.fetchAds = function(initOptions) {
        var _a;
        return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__awaiter(this, void 0, Promise, function() {
            var _b, _c;
            return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (initOptions.isLive && ((_a = initOptions.adBreakVASTList) === null || _a === void 0 ? void 0 : _a.length) > 1) return [
                            2 /*return*/ 
                        ];
                        if (!initOptions.vmapUrl) return [
                            3 /*break*/ ,
                            2
                        ];
                        _b = this;
                        return [
                            4 /*yield*/ ,
                            this.adServerService.getVMAP(initOptions.vmapUrl)
                        ];
                    case 1:
                        _b.adBreaks = _d.sent();
                        _d.label = 2;
                    case 2:
                        if (!initOptions.adBreakVASTList) return [
                            3 /*break*/ ,
                            4
                        ];
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this.adServerService.getVASTs(initOptions.adBreakVASTList)
                        ];
                    case 3:
                        _c.adBreaks = _d.sent();
                        _d.label = 4;
                    case 4:
                        this.adBreaks = this.adBreaks.sort(function(a, b) {
                            return a.timeOffset - b.timeOffset;
                        });
                        this.adMarkers = this.adBreaks.map(function(adBreak) {
                            return adBreak.timeOffset;
                        });
                        this.start();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.play = function() {
        if (this.state !== "idle") return;
        this.state = "playing";
        this.playNextVideo();
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.fetchAdBreak = function(vastUrl) {
        return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__awaiter(this, void 0, Promise, function() {
            var adBreak;
            return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.adServerService.getVast(vastUrl)
                        ];
                    case 1:
                        adBreak = _a.sent();
                        if (adBreak) this.adBreaks.push(adBreak);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.triggerAdBreak = function() {
        return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__awaiter(this, void 0, Promise, function() {
            return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__generator(this, function(_a) {
                if (!this.adBreaks || this.adBreaks.length === 0) return [
                    2 /*return*/ 
                ];
                this.playAdBreak(this.adBreaks.shift());
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.start = function() {
        var _this = this;
        if (this.adMarkers[0] === 0) {
            this.adMarkers.shift();
            this.playAdBreak(this.adBreaks.shift());
        } else {
            var nextBreak = this.adMarkers.find(function(adMarker) {
                return adMarker > _this.contentVideoElement.currentTime;
            });
            if (!nextBreak) return;
            this.contentVideoElement.addEventListener("timeupdate", this.onContentTimeUpdateRef = this.onContentTimeUpdate.bind(this));
        }
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playAdBreak = function(adbreak) {
        if (this.autoManagePlayback) this.contentVideoElement.pause();
        this.currentAdBreak = adbreak;
        this.trackAdBreakEvent(this.currentAdBreak, $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_START);
        for(var _i = 0, _a = adbreak.ads; _i < _a.length; _i++){
            var ad = _a[_i];
            this.currentAdBreakVideos.push(ad);
        }
        this.playNextVideo();
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playNextVideo = function() {
        this.videoEventFilter.clear();
        this.adVideoElement.removeEventListener("seeking", this.onAdSeekingRef);
        var ad = this.currentAdBreakVideos.shift();
        if (ad) this.playAd(ad);
        else this.playContent();
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playAd = function(ad) {
        var _this = this;
        var src = ad.creative.mediafiles[0].fileUrl;
        if (this.debug) console.debug("[CSAIManager] play ad", ad);
        if (!src) return this.playNextVideo();
        this.currentAd = ad;
        this.adVideoElement.style.display = "block";
        this.adVideoElement.src = src;
        if (this.state !== "idle" || this.initOptions.autoplay) this.adVideoElement.play();
        this.adVideoElement.addEventListener("playing", function() {
            _this.trackEvent($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.START, _this.currentAd);
            _this.trackEvent($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.IMPRESSION, _this.currentAd);
            _this.state = "playing";
        }, {
            once: true
        });
        this.adVideoElement.addEventListener("ended", function() {
            _this.trackEvent($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.COMPLETE, _this.currentAd);
            _this.state = "ended";
            _this.validCurrentTime = 0;
            _this.playNextVideo();
        }, {
            once: true
        });
        this.videoEventFilter.addEventListener($ceb203e02a2dd5c7$exports.PlayerEvents.TimeUpdate, function() {
            if (!_this.adVideoElement.seeking) _this.validCurrentTime = _this.adVideoElement.currentTime;
            _this.monitorProgress();
        });
        this.videoEventFilter.addEventListener($ceb203e02a2dd5c7$exports.PlayerEvents.Pause, function() {
            _this.trackEvent($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.PAUSE, _this.currentAd);
        });
        this.videoEventFilter.addEventListener($ceb203e02a2dd5c7$exports.PlayerEvents.Resume, function() {
            _this.trackEvent($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.RESUME, _this.currentAd);
        });
        this.videoEventFilter.addEventListener($ceb203e02a2dd5c7$exports.PlayerEvents.Error, function() {
            _this.trackEvent($8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.ERROR, _this.currentAd);
        });
        // this has to be native to block seek properly
        this.adVideoElement.addEventListener("seeking", this.onAdSeekingRef = function() {
            var delta = _this.adVideoElement.currentTime - _this.validCurrentTime;
            if (Math.abs(delta) > 0.01) _this.adVideoElement.currentTime = _this.validCurrentTime;
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.playContent = function() {
        var _this = this;
        if (this.debug) console.debug("[CSAIManager] play content");
        this.adVideoElement.style.display = "none";
        this.adVideoElement.src = "";
        if (this.currentAdBreak) {
            this.trackAdBreakEvent(this.currentAdBreak, $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$8ee40f6ae4909ee9.BREAK_END);
            this.currentAdBreak = null;
        }
        if (this.autoManagePlayback) this.contentVideoElement.play();
        var nextBreak = this.adMarkers.find(function(adMarker) {
            return adMarker > _this.contentVideoElement.currentTime;
        });
        if (!nextBreak) return;
        if (this.debug) console.debug("[CSAIManager] waiting for next break", nextBreak);
        this.contentVideoElement.addEventListener("timeupdate", this.onContentTimeUpdateRef = this.onContentTimeUpdate.bind(this));
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.onContentTimeUpdate = function() {
        var currentTime = this.contentVideoElement.currentTime;
        var nextBreak = this.adMarkers[0];
        if (currentTime > nextBreak) {
            this.contentVideoElement.removeEventListener("timeupdate", this.onContentTimeUpdateRef);
            this.adMarkers.shift();
            this.playAdBreak(this.adBreaks.shift());
        }
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.monitorProgress = function() {
        var _this = this;
        var currentTime = this.adVideoElement.currentTime;
        var duration = this.adVideoElement.duration;
        if (!this.currentAd) return;
        var remainingTime = duration - currentTime;
        var percentWatched = Math.round(100 - 100 * remainingTime / duration);
        var TrackingCuePoints = {
            25: $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.FIRST_QUARTILE,
            50: $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.MIDPOINT,
            75: $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.THIRD_QUARTILE
        };
        Object.keys(TrackingCuePoints).map(function(value) {
            var event = TrackingCuePoints[value];
            if (percentWatched > parseInt(value, 10) && _this.currentAd) _this.trackEvent(event, _this.currentAd);
        });
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.trackAdBreakEvent = function(adBreak, trackingEvent) {
        var _this = this;
        if (!adBreak || !adBreak.trackingEvents || !trackingEvent || this.trackedAdBreaks[adBreak.timeOffset] && this.trackedAdBreaks[adBreak.timeOffset][trackingEvent] === true) return;
        if (!this.trackedAdBreaks[adBreak.timeOffset]) this.trackedAdBreaks[adBreak.timeOffset] = {};
        this.emit(trackingEvent, adBreak);
        var trackingUrls = adBreak.trackingEvents[trackingEvent] || [];
        trackingUrls.forEach(function(url) {
            return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__awaiter(_this, void 0, void 0, function() {
                return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__generator(this, function(_a) {
                    if (this.debug) console.debug("[CSAIManager] ad break tracking event -> ".concat(trackingEvent), url);
                    new Image().src = url;
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        });
        this.trackedAdBreaks[adBreak.timeOffset][trackingEvent] = true;
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.trackEvent = function(trackingEvent, ad) {
        var _this = this;
        if (!ad || !trackingEvent || this.trackedAds[ad.id] && this.trackedAds[ad.id][trackingEvent] === true) return;
        if (!this.trackedAds[ad.id]) this.trackedAds[ad.id] = {};
        var trackingUrls = [];
        switch(trackingEvent){
            case $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.IMPRESSION:
                trackingUrls = ad.impressionUrlTemplates || [];
                break;
            case $8e77a7afa455b288$var$$6a91d1a6b96ec270$export$af003d03c08e493d.ERROR:
                trackingUrls = ad.errorUrlTemplates || [];
                break;
            default:
                trackingUrls = ad.creative.trackingEvents[trackingEvent] || [];
                break;
        }
        this.emit(trackingEvent, ad);
        trackingUrls === null || trackingUrls === void 0 || trackingUrls.forEach(function(url) {
            return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__awaiter(_this, void 0, void 0, function() {
                return $8e77a7afa455b288$var$$020ad56d15653aeb$var$__generator(this, function(_a) {
                    if (this.debug) console.debug("[CSAIManager] ad tracking event -> ".concat(trackingEvent), url);
                    new Image().src = url;
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        });
        this.trackedAds[ad.id][trackingEvent] = true;
    };
    $020ad56d15653aeb$export$b74fc88014c397b3.prototype.destroy = function() {
        this.adBreaks = [];
        this.adMarkers = [];
        this.currentAd = null;
        this.currentAdBreak = null;
        this.currentAdBreakVideos = [];
        this.onContentTimeUpdateRef = null;
        this.onAdSeekingRef = null;
        this.trackedAdBreaks = {};
        this.trackedAds = {};
        this.videoEventFilter.clear();
        this.videoEventFilter.destroy();
        // if not sent in as a video element already in DOM, let's remove the created ad video element as well
        if (!this.initOptions.adVideoElement) this.adVideoElement.remove();
    };
    return $020ad56d15653aeb$export$b74fc88014c397b3;
}($8e77a7afa455b288$var$$cc312ea0fc7c8651$export$691d3e4b1045a188);
$8e77a7afa455b288$var$$parcel$exportWildcard($8e77a7afa455b288$exports, $8e77a7afa455b288$var$$020ad56d15653aeb$exports);


var $5a659d70398da667$var$Message;
(function(Message) {
    Message["NO_MEDIA"] = "no-media";
    Message["MEDIA_RECOVERED"] = "media-recovered";
    Message["PEER_CONNECTION_FAILED"] = "peer-connection-failed";
    Message["INITIAL_CONNECTION_FAILED"] = "initial-connection-failed";
})($5a659d70398da667$var$Message || ($5a659d70398da667$var$Message = {}));
const $5a659d70398da667$var$MediaConstraintsDefaults = {
    audioOnly: false,
    videoOnly: false
};
const $5a659d70398da667$var$RECONNECT_ATTEMPTS = 2;
class $5a659d70398da667$export$f6039712bf1ca949 extends (0, $a64e4d4dddecbac4$exports.EventEmitter) {
    videoElement;
    peer = {};
    adapterType;
    adapterFactory = undefined;
    iceServers;
    debug;
    channelUrl = {};
    reconnectAttemptsLeft = $5a659d70398da667$var$RECONNECT_ATTEMPTS;
    csaiManager;
    adapter = {};
    statsInterval;
    statsTypeFilter = undefined;
    msStatsInterval = 5000;
    mediaTimeoutOccured = false;
    mediaTimeoutThreshold = 30000;
    timeoutThresholdCounter = 0;
    bytesReceived = 0;
    mediaConstraints;
    constructor(opts){
        super();
        this.mediaConstraints = {
            ...$5a659d70398da667$var$MediaConstraintsDefaults,
            ...opts.mediaConstraints
        };
        this.videoElement = opts.video;
        this.adapterType = opts.type;
        this.adapterFactory = opts.adapterFactory;
        this.statsTypeFilter = opts.statsTypeFilter;
        this.mediaTimeoutThreshold = opts.timeoutThreshold ?? this.mediaTimeoutThreshold;
        this.iceServers = [
            {
                urls: "stun:stun.l.google.com:19302"
            }
        ];
        if (opts.iceServers) this.iceServers = opts.iceServers;
        this.debug = !!opts.debug;
        if (opts.vmapUrl) {
            this.csaiManager = new (0, $8e77a7afa455b288$exports.CSAIManager)({
                contentVideoElement: this.videoElement,
                vmapUrl: opts.vmapUrl,
                isLive: true,
                autoplay: true
            });
            this.videoElement.addEventListener("ended", ()=>{
                if (this.csaiManager) this.csaiManager.destroy();
            });
        }
    }
    async load(channelUrl) {
        this.channelUrl = channelUrl;
        this.connect();
    }
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    log(...args) {
        if (this.debug) console.log("WebRTC-player", ...args);
    }
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    error(...args) {
        console.error("WebRTC-player", ...args);
    }
    async onConnectionStateChange() {
        if (this.peer.connectionState === "failed") {
            this.emit($5a659d70398da667$var$Message.PEER_CONNECTION_FAILED);
            this.peer && this.peer.close();
            if (this.reconnectAttemptsLeft <= 0) {
                this.error("Connection failed, reconnecting failed");
                return;
            }
            this.log(`Connection failed, recreating peer connection, attempts left ${this.reconnectAttemptsLeft}`);
            await this.connect();
            this.reconnectAttemptsLeft--;
        } else if (this.peer.connectionState === "connected") {
            this.log("Connected");
            this.reconnectAttemptsLeft = $5a659d70398da667$var$RECONNECT_ATTEMPTS;
        }
    }
    onErrorHandler(error) {
        this.log(`onError=${error}`);
        switch(error){
            case "reconnectneeded":
                this.peer && this.peer.close();
                this.videoElement.srcObject = null;
                this.setupPeer();
                this.adapter.resetPeer(this.peer);
                this.adapter.connect();
                break;
            case "connectionfailed":
                this.peer && this.peer.close();
                this.videoElement.srcObject = null;
                this.emit($5a659d70398da667$var$Message.INITIAL_CONNECTION_FAILED);
                break;
        }
    }
    async onConnectionStats() {
        if (this.peer && this.statsTypeFilter) {
            let bytesReceivedBlock = 0;
            const stats = await this.peer.getStats(null);
            stats.forEach((report)=>{
                if (report.type.match(this.statsTypeFilter)) this.emit(`stats:${report.type}`, report);
                //inbound-rtp attribute bytesReceived from stats report will contain the total number of bytes received for this SSRC.
                //In this case there are several SSRCs. They are all added together in each onConnectionStats iteration and compared to their value during the previous iteration.
                if (report.type.match("inbound-rtp")) bytesReceivedBlock += report.bytesReceived;
            });
            if (bytesReceivedBlock <= this.bytesReceived) {
                this.timeoutThresholdCounter += this.msStatsInterval;
                if (this.mediaTimeoutOccured === false && this.timeoutThresholdCounter >= this.mediaTimeoutThreshold) {
                    this.emit($5a659d70398da667$var$Message.NO_MEDIA);
                    this.mediaTimeoutOccured = true;
                }
            } else {
                this.bytesReceived = bytesReceivedBlock;
                this.timeoutThresholdCounter = 0;
                if (this.mediaTimeoutOccured == true) {
                    this.emit($5a659d70398da667$var$Message.MEDIA_RECOVERED);
                    this.mediaTimeoutOccured = false;
                }
            }
        }
    }
    setupPeer() {
        this.peer = new RTCPeerConnection({
            iceServers: this.iceServers
        });
        this.peer.onconnectionstatechange = this.onConnectionStateChange.bind(this);
        this.peer.ontrack = this.onTrack.bind(this);
    }
    onTrack(event) {
        for (const stream of event.streams){
            if (stream.id === "feedbackvideomslabel") continue;
            console.log("Set video element remote stream to " + stream.id, " audio " + stream.getAudioTracks().length + " video " + stream.getVideoTracks().length);
            // Create a new MediaStream if we don't have one
            if (!this.videoElement.srcObject) this.videoElement.srcObject = new MediaStream();
            // We might have one stream of both audio and video, or separate streams for audio and video
            for (const track of stream.getTracks())this.videoElement.srcObject.addTrack(track);
        }
    }
    async connect() {
        this.setupPeer();
        if (this.adapterType !== "custom") this.adapter = (0, $c670b344820fffeb$export$4f24674036ad9ae3)(this.adapterType, this.peer, this.channelUrl, this.onErrorHandler.bind(this), this.mediaConstraints);
        else if (this.adapterFactory) this.adapter = this.adapterFactory(this.peer, this.channelUrl, this.onErrorHandler.bind(this), this.mediaConstraints);
        if (!this.adapter) throw new Error(`Failed to create adapter (${this.adapterType})`);
        if (this.debug) this.adapter.enableDebug();
        this.statsInterval = setInterval(this.onConnectionStats.bind(this), this.msStatsInterval);
        try {
            await this.adapter.connect();
        } catch (error) {
            console.error(error);
            this.stop();
        }
    }
    mute() {
        this.videoElement.muted = true;
    }
    unmute() {
        this.videoElement.muted = false;
    }
    async unload() {
        await this.adapter.disconnect();
        this.stop();
    }
    stop() {
        clearInterval(this.statsInterval);
        this.peer.close();
        this.videoElement.srcObject = null;
        this.videoElement.load();
    }
    destroy() {
        this.stop();
        this.removeAllListeners();
    }
}


window.WebRTCPlayer = (0, $5a659d70398da667$export$f6039712bf1ca949);

})();
//# sourceMappingURL=webrtc-player-0.12.1.js.map
